var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFinalSetup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "380px",
    height: "332px",
    viewBox: "0 0 380 332",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 380,
    height: 332
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.450079,7.92734499 C93.8491256,12.2842607 55.7750397,20.0936407 47.1397456,44.7807631 L47.1397456,44.7807631 C41.6890302,60.363275 50.9446741,74.1570747 40.3950715,86.5747218 L40.3950715,86.5747218 C30.53593,98.1798092 16.2972973,93.3786963 6.30620032,107.595231 L6.30620032,107.595231 C5.48298887,108.766137 -0.645945946,117.747854 0.0624801272,129.5 L0.0624801272,129.5 C1.20302067,148.411288 18.7036566,152.191097 23.1098569,170.841017 L23.1098569,170.841017 C27.4491256,189.209698 13.1704293,196.96407 16.6278219,208.436248 L16.6278219,208.436248 C20.1308426,220.061049 40.5791733,236.127822 155.593323,232.557234 L155.593323,232.557234 C272.141335,228.938315 296.127822,206.374722 310.839905,190.304134 L310.839905,190.304134 C337.872337,160.775199 313.334658,121.700636 306.527981,107.215898 L306.527981,107.215898 C291.96089,76.218601 310.839905,65.772814 303.445628,39.9702703 L303.445628,39.9702703 C294.857393,10.000318 247.913514,0.112718601 198.127981,0.112718601 L198.127981,0.112718601 C169.610016,0.112718601 140.162162,3.35612083 116.450079,7.92734499",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "38.2557922%",
    y1: "35.5245122%",
    x2: "75.558013%",
    y2: "88.8333782%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFCA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC4FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M341.844092,0.645678947 L341.844092,24.3298526 C22.0309728,11.5249053 53.5784871,294.349937 54.3546251,300.919658 L0.159766423,300.963111",
    id: "path-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.844035,0.566210612 L288.844035,24.6853355 C-4.44101964,5.67047265 49.8033496,276.883095 49.8033496,276.883095 L1.25089552,276.919727",
    id: "path-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.844243,0.30487126 L391.844243,24.6188065 C45.9862024,9.56816284 50.2621538,314.819154 50.4915951,324.736969 L0.0791255061,324.776096",
    id: "path-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2133545,0.0502384738 C13.9249603,2.85914149 7.37106518,4.15564388 2.68950715,4.33577107 L2.68950715,4.33577107 C-1.99189189,4.51589825 0.888871224,8.62082671 0.888871224,8.62082671 L0.888871224,8.62082671 L13.3489666,8.62082671 L15.7014308,6.10015898 L16.445469,8.62082671 L21.7755167,8.62082671 C22.927663,4.22766296 20.4069952,0.0502384738 20.4069952,0.0502384738 L20.4069952,0.0502384738 C20.4069952,0.0502384738 15.7976153,0.33863275 14.2133545,0.0502384738",
    id: "path-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "43.1667701%",
    y1: "46.0147919%",
    x2: "54.9174147%",
    y2: "55.4813317%",
    id: "linearGradient-14"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC33",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7B60",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.05564388,0.237519873 C2.05564388,0.237519873 1.09507154,3.21430843 0.0386327504,6.09507154 L0.0386327504,6.09507154 C1.38346582,7.34387917 1.7672496,11.7612083 1.19125596,16.4667727 L1.19125596,16.4667727 C0.615262321,21.1718601 4.36025437,21.5561208 4.74419714,19.2515103 L4.74419714,19.2515103 C5.12861685,16.9467409 6.47281399,10.0324324 6.47281399,10.0324324 L6.47281399,10.0324324 L5.32019078,7.63211447 L7.4327504,7.05564388 L7.4327504,1.67790143 C5.67694754,0.375198728 4.12209857,0.108108108 3.14165342,0.108108108 L3.14165342,0.108108108 C2.45977742,0.108108108 2.05564388,0.237519873 2.05564388,0.237519873",
    id: "path-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "42.6826878%",
    y1: "51.3007669%",
    x2: "56.1777985%",
    y2: "48.4924058%",
    id: "linearGradient-17"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC33",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7B60",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.454531002,0.108744038 C0.454531002,0.108744038 -0.317011129,10.4802862 0.454531002,29.709062 L0.454531002,29.709062 C1.22607313,48.9394277 5.44403816,69.681558 5.44403816,69.681558 L5.44403816,69.681558 C9.40508744,71.3389507 14.2314785,69.681558 14.2314785,69.681558 L14.2314785,69.681558 L15.6718601,52.1085851 C16.2763116,44.7281399 17.5421304,37.7771065 18.8073132,32.1995231 L18.8073132,32.1995231 C19.9704293,27.0688394 21.1335453,23.099682 21.7804452,21.0205087 L21.7804452,21.0205087 C22.1027027,19.9772655 22.2977742,19.4111288 22.2977742,19.4111288 L22.2977742,19.4111288 L12.1391097,0.108744038 L0.454531002,0.108744038 Z",
    id: "path-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "46.4412996%",
    y1: "69.3888649%",
    x2: "50.6110574%",
    y2: "23.907201%",
    id: "linearGradient-20"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F5B9A",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17386B",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.121144674,8.85278219 C0.121144674,8.85278219 4.68298887,29.1627981 27.00938,43.8556439 L27.00938,43.8556439 C49.336248,58.5478537 61.5799682,59.9882353 61.5799682,59.9882353 L61.5799682,59.9882353 C61.5799682,59.9882353 65.7572337,56.5314785 64.6050874,50.481558 L64.6050874,50.481558 C64.6050874,50.481558 41.6626391,40.9747218 32.463434,17.9279809 L32.463434,17.9279809 C21.5354531,4.24324324 18.3794913,0.154372019 18.3794913,0.154372019 L18.3794913,0.154372019 L0.121144674,8.85278219 Z",
    id: "path-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "59.6601045%",
    y1: "71.6044363%",
    x2: "33.6059292%",
    y2: "14.7525349%",
    id: "linearGradient-23"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F5B9A",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17386B",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.5327504,0.968203498 C6.34054054,2.74467409 7.58871224,6.68203498 7.10890302,7.49809221 L7.10890302,7.49809221 C6.62893482,8.31462639 5.57233704,5.91383148 4.61192369,3.94515103 L4.61192369,3.94515103 C3.65198728,1.97647059 2.25930048,2.64864865 3.50763116,5.28950715 L3.50763116,5.28950715 C4.75627981,7.93020668 5.7645469,11.7713831 5.47631161,12.7317965 L5.47631161,12.7317965 C5.32750397,13.2278219 3.97488076,13.1217806 2.66852146,13.0158983 L2.66852146,13.0158983 C1.44499205,12.9170111 0.26263911,12.8176471 0.146899841,13.2119237 L0.146899841,13.2119237 C-0.093163752,14.0278219 2.64324324,14.6523052 4.08410175,14.8922099 L4.08410175,14.8922099 C5.52464229,15.1327504 7.45151033,18.3496025 7.28012719,18.9255962 L7.28012719,18.9255962 L12.9666137,17.8213037 C12.9666137,17.8213037 11.8144674,15.6127186 12.9666137,12.6836248 L12.9666137,12.6836248 C14.1192369,9.75500795 14.8874404,4.71335453 14.1192369,4.18505564 L14.1192369,4.18505564 C13.3510334,3.65675676 13.0944356,6.44213037 12.45469,7.59411765 L12.45469,7.59411765 C11.8144674,8.74689984 11.382194,8.07472178 11.6222576,5.6254372 L11.6222576,5.6254372 C11.8621622,3.17678855 12.4481717,1.30429253 11.5553259,1.25643879 L11.5553259,1.25643879 C10.6618442,1.20826709 9.96613672,5.55357711 9.77392687,6.65786963 L9.77392687,6.65786963 C9.58171701,7.76216216 8.78314785,6.39761526 8.40540541,3.2009539 L8.40540541,3.2009539 C8.15119237,1.05055644 7.53068362,0.00874403816 7.06804452,0.00874403816 L7.06804452,0.00874403816 C6.81033386,0.00874403816 6.60158983,0.332432432 6.5327504,0.968203498",
    id: "path-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "39.3820328%",
    y1: "40.4974486%",
    x2: "89.4479097%",
    y2: "73.6209196%",
    id: "linearGradient-26"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9BFCA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB99BA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.78426073,3.02877583 C5.42686804,6.05071542 4.67233704,7.34069952 4.49046105,6.29666137 L4.49046105,6.29666137 C4.30922099,5.25278219 3.6508744,1.14531002 2.80683625,1.19077901 L2.80683625,1.19077901 C1.96279809,1.236407 2.5163752,3.0063593 2.74308426,5.32098569 L2.74308426,5.32098569 C2.97058824,7.6354531 2.56200318,8.2709062 1.95675676,7.18139905 L1.95675676,7.18139905 C1.35166932,6.09252782 1.10953895,3.45993641 0.383465819,3.95898251 L0.383465819,3.95898251 C-0.343084261,4.45866455 0.383465819,9.22368839 1.47249603,11.9923688 L1.47249603,11.9923688 C2.56200318,14.7605723 1.47249603,16.8484897 1.47249603,16.8484897 L1.47249603,16.8484897 L6.84737679,17.8923688 C6.68600954,17.3476948 8.50699523,14.3069952 9.86883943,14.0798092 L9.86883943,14.0798092 C11.2302067,13.8529412 13.8171701,13.2631161 13.5903021,12.4915739 L13.5903021,12.4915739 C13.4799682,12.1187599 12.3624801,12.2125596 11.2065183,12.3060413 L11.2065183,12.3060413 C9.97154213,12.4065183 8.69316375,12.5065183 8.55246423,12.0375199 L8.55246423,12.0375199 C8.28012719,11.1297297 9.23338633,7.49936407 10.4135135,5.00302067 L10.4135135,5.00302067 C11.5930048,2.50715421 10.2774245,1.87170111 9.36963434,3.73227345 L9.36963434,3.73227345 C8.46200318,5.59332273 7.463593,7.86232114 7.00937997,7.09077901 L7.00937997,7.09077901 C6.55580286,6.31923688 7.7354531,2.59777424 7.55421304,0.918441971 L7.55421304,0.918441971 C7.48903021,0.317488076 7.29189189,0.0116056615 7.0481717,0.0116056615 L7.0481717,0.0116056615 C6.61096979,0.0116056615 6.02448331,0.996502385 5.78426073,3.02877583",
    id: "path-27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "39.3787463%",
    y1: "22.1389317%",
    x2: "57.3387869%",
    y2: "99.8774148%",
    id: "linearGradient-29"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9BFCA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB99BA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.85993641,4.43163752 L0.0890302067,40.4426073 L5.85993641,49.8054054 C5.85993641,49.8054054 22.754849,51.427027 32.4313196,40.4607313 L32.4313196,40.4607313 C33.1764706,30.0709062 27.7031797,18.8356121 27.7031797,18.8356121 L27.7031797,18.8356121 L19.1804452,0.0241653418 L5.85993641,4.43163752 Z",
    id: "path-30"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "40.7555262%",
    cy: "42.6351359%",
    fx: "40.7555262%",
    fy: "42.6351359%",
    r: "75.2654475%",
    gradientTransform: "translate(0.407555,0.426351),scale(1.000000,0.649986),translate(-0.407555,-0.426351)",
    id: "radialGradient-32"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF2F2",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4E9FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.990461,1.59682035 C16.4659777,1.88298887 16.1343402,2.42670906 16.1262321,3.02352941 L16.1262321,3.02352941 C16.0597774,7.67249603 15.2354531,28.9138315 5.75993641,34.6753577 L5.75993641,34.6753577 C1.40810811,41.0801272 0.0950715421,42.3826709 0.0950715421,42.3826709 L0.0950715421,42.3826709 L0.649761526,43.7017488 L1.72718601,46.2710652 C1.72718601,46.2710652 7.28616852,66.2136725 10.6572337,76.3761526 L10.6572337,76.3761526 C12.9696343,83.34531 17.8718601,89.3643879 22.4379968,93.7976153 L22.4379968,93.7976153 C27.6421304,98.8513514 32.4081081,101.847536 32.4081081,101.847536 L32.4081081,101.847536 C32.4081081,101.847536 39.3217806,93.3017488 41.0510334,82.6422893 L41.0510334,82.6422893 C41.0510334,82.6422893 28.5664547,82.0662957 23.8613672,69.6771065 L23.8613672,69.6771065 C19.1558029,57.2901431 17.572655,53.9041335 21.3891892,42.7774245 L21.3891892,42.7774245 C25.0282989,32.1680445 27.6861685,10.1969793 25.6774245,1.30810811 L25.6774245,1.30810811 C25.5103339,0.56836248 24.8618442,0.0384737679 24.1034976,0.0225755167 L24.1034976,0.0225755167 C23.9952305,0.020190779 23.8812401,0.0189189189 23.7618442,0.0189189189 L23.7618442,0.0189189189 C22.10938,0.0189189189 19.4281399,0.265341812 16.990461,1.59682035",
    id: "path-33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "45.9916695%",
    y1: "9.83971605%",
    x2: "51.7949257%",
    y2: "79.0123198%",
    id: "linearGradient-35"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC33",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7B60",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.12225755,0.303020668 C6.12225755,0.303020668 1.2254372,9.95421304 0.217329094,30.2647059 L0.217329094,30.2647059 C-0.791414944,50.5740859 5.40333863,58.5443561 6.36263911,61.5224165 L6.36263911,61.5224165 C7.32432432,64.4987281 3.67408585,89.4659777 2.90588235,95.9968203 L2.90588235,95.9968203 C3.86740859,98.7810811 18.9600954,100.893641 18.9600954,100.893641 L18.9600954,100.893641 C18.9600954,100.893641 17.6607313,97.5860095 16.5651828,91.1802862 L16.5651828,91.1802862 C15.9705882,87.7031797 15.4340223,83.3101749 15.1972973,78.0383148 L15.1972973,78.0383148 C14.5251192,63.0583466 19.4340223,48.654849 19.4340223,48.654849 L19.4340223,48.654849 L19.5799682,47.8146264 L20.3109698,43.6066773 C20.3109698,43.6066773 19.600318,41.7780604 17.6085851,34.1537361 L17.6085851,34.1537361 C7.57472178,22.7311606 14.0930048,2.03227345 14.0930048,2.03227345 L14.0930048,2.03227345 C12.0472178,0.455961844 9.71462639,0.121621622 8.10381558,0.121621622 L8.10381558,0.121621622 C6.91732909,0.121621622 6.12225755,0.303020668 6.12225755,0.303020668",
    id: "path-36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.2007331%",
    y1: "15.6148593%",
    x2: "49.7708392%",
    y2: "80.7956486%",
    id: "linearGradient-38"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC33",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7B60",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-39",
    points: "0.0694753577 2.63338633 0.0694753577 5.41812401 1.60540541 8.53879173 3.95786963 7.19459459 5.82988871 4.0200318 6.05993641 1.68887122 6.21478537 0.135930048"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "28.8631447%",
    y1: "65.5300155%",
    x2: "73.6813192%",
    y2: "37.6742054%",
    id: "linearGradient-41"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9BFCA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB99BA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.3739269,0.642130366 C23.3739269,0.642130366 20.3969793,12.0933227 10.3856916,19.6556439 L10.3856916,19.6556439 C1.82225755,26.1244833 0.158982512,32.4033386 0.158982512,32.4033386 L0.158982512,32.4033386 C-0.20127186,36.2209857 3.68775835,45.4392687 3.68775835,45.4392687 L3.68775835,45.4392687 C5.56041335,42.3427663 14.9232114,38.0934817 14.9232114,38.0934817 L14.9232114,38.0934817 C14.5629571,32.9079491 18.9565978,27.5780604 22.9351351,18.0712242 L22.9351351,18.0712242 C26.9136725,8.56406995 25.0300477,0.353895072 25.0300477,0.353895072 L25.0300477,0.353895072 L23.6379968,0.0419713831 L23.3739269,0.642130366 Z",
    id: "path-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "43.1395758%",
    y1: "43.4417643%",
    x2: "55.7734737%",
    y2: "53.3837131%",
    id: "linearGradient-44"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E7EE4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B2FBF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.0356120827,1.49284579 C0.0356120827,1.49284579 0.827980922,3.65373609 1.1163752,3.8217806 L1.1163752,3.8217806 C1.40413355,3.98982512 2.72480127,4.13370429 3.13290938,3.8217806 L3.13290938,3.8217806 C3.54085851,3.50937997 4.06915739,1.49284579 4.06915739,1.49284579 L4.06915739,1.49284579 L2.96470588,0.292368839 L2.02845787,0.100158983 C2.02845787,0.100158983 1.98775835,0.0949125596 1.91701113,0.0949125596 L1.91701113,0.0949125596 C1.58791733,0.0949125596 0.608585056,0.208744038 0.0356120827,1.49284579",
    id: "path-45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "21.0417406%",
    y1: "48.8607562%",
    x2: "76.3946916%",
    y2: "51.0247695%",
    id: "linearGradient-47"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E7EE4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B2FBF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.4254372,2.06136725 C0.576947536,3.2618442 0.120667727,3.59777424 0.120667727,3.59777424 L0.120667727,3.59777424 C0.120667727,3.59777424 1.96915739,5.01462639 2.37774245,6.71923688 L2.37774245,6.71923688 C2.37774245,6.71923688 3.69777424,3.83847377 4.70604134,2.94992051 L4.70604134,2.94992051 C5.71414944,2.06136725 5.38426073,0.407949126 4.16899841,0.118600954 L4.16899841,0.118600954 C4.16899841,0.118600954 4.27376789,0.861526232 2.4254372,2.06136725",
    id: "path-48"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.002348888%",
    y1: "49.9961896%",
    x2: "100.004807%",
    y2: "49.9961896%",
    id: "linearGradient-50"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F5B9A",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17386B",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.254531002,1.11096979 C0.0623211447,1.66279809 0.13481717,5.12034976 0.13481717,5.12034976 L0.13481717,5.12034976 C0.590620032,3.96772655 2.82337043,2.16693164 2.82337043,2.16693164 L2.82337043,2.16693164 C1.38298887,1.83100159 1.0227345,0.0786963434 1.0227345,0.0786963434 L1.0227345,0.0786963434 C1.0227345,0.0786963434 0.446740859,0.558664547 0.254531002,1.11096979",
    id: "path-51"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.0027598985%",
    y1: "49.9956149%",
    x2: "100.005672%",
    y2: "49.9956149%",
    id: "linearGradient-53"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F5B9A",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17386B",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.103020668,0.778060413 C0.103020668,0.778060413 2.07170111,2.79443561 1.30349762,6.7799682 L1.30349762,6.7799682 C0.535294118,10.7651828 -0.376947536,13.982035 3.46438792,13.3098569 L3.46438792,13.3098569 C7.30556439,12.6378378 12.1551669,9.63672496 12.1551669,9.63672496 L12.1551669,9.63672496 L13.2594595,9.15675676 L14.027027,6.15564388 L9.1782194,0.0580286169 L0.103020668,0.778060413 Z",
    id: "path-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "8.08221153%",
    y1: "52.9160834%",
    x2: "65.4969813%",
    y2: "42.2607573%",
    id: "linearGradient-56"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9BFCA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB99BA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.190620032,12.2759936 C1.38823529,22.9755167 15.3151033,19.7300477 15.3151033,19.7300477 L15.3151033,19.7300477 C16.6834658,22.4313196 14.8828299,26.500318 14.8828299,26.500318 L14.8828299,26.500318 C17.3321145,26.1039746 17.7642289,24.3039746 17.7642289,24.3039746 L17.7642289,24.3039746 C19.7790143,25.2863275 18.1965024,27.7607313 18.1965024,27.7607313 L18.1965024,27.7607313 C20.1410175,29.4174881 23.727345,27.0759936 22.5753577,25.1314785 L22.5753577,25.1314785 C21.4225755,23.1863275 22.9497615,23.0793323 22.8779014,20.990938 L22.8779014,20.990938 C22.8054054,18.9020668 19.6368839,17.8217806 19.6368839,17.8217806 L19.6368839,17.8217806 C19.6368839,17.8217806 21.0772655,14.6527822 18.8443561,12.8521463 L18.8443561,12.8521463 C16.6116057,11.0515103 11.9302067,13.1403816 9.55341812,8.74674086 L9.55341812,8.74674086 C7.17678855,4.35357711 11.7143084,1.1845787 11.7143084,1.1845787 L11.7143084,1.1845787 C10.6950715,0.474085851 9.53386328,0.134817114 8.34848967,0.134817114 L8.34848967,0.134817114 C4.00524642,0.135135135 -0.657869634,4.69427663 0.190620032,12.2759936",
    id: "path-57"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "54.8624646%",
    y1: "19.6983063%",
    x2: "49.0784739%",
    y2: "69.4356545%",
    id: "linearGradient-59"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#873B50",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F2649",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.0243243243,0.0567567568 L0.0243243243,6.03481717 L6.36248013,11.0758347 C6.36248013,11.0758347 9.74737679,11.5081081 10.0351351,10.2841017 L10.0351351,10.2841017 C10.3235294,9.05945946 7.80286169,6.75468998 6.5063593,5.17042925 L6.5063593,5.17042925 C5.20985692,3.58569157 6.07424483,0.0567567568 6.07424483,0.0567567568 L6.07424483,0.0567567568 L0.0243243243,0.0567567568 Z",
    id: "path-60"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "83.4471656%",
    y1: "39.4250878%",
    x2: "12.3919636%",
    y2: "58.2531663%",
    id: "linearGradient-62"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9BFCA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB99BA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.24197138,6.86263911 C2.53831479,9.24038156 1.52957075,13.2710652 1.52957075,13.2710652 L1.52957075,13.2710652 L3.83434022,13.2710652 C3.83434022,13.2710652 3.83434022,9.0217806 4.48282989,9.0217806 L4.48282989,9.0217806 C5.13084261,9.0217806 7.86772655,13.1265501 11.0368839,13.5593005 L11.0368839,13.5593005 C14.2058824,13.990938 19.463434,13.6306836 19.1031797,12.3346582 L19.1031797,12.3346582 C18.7429253,11.0381558 12.1796502,6.86263911 12.1796502,6.86263911 L12.1796502,6.86263911 C8.06502385,9.52861685 2.25007949,0.0910969793 2.25007949,0.0910969793 L2.25007949,0.0910969793 C-0.776788553,1.30572337 -0.0546899841,4.48426073 1.24197138,6.86263911",
    id: "path-63"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "58.0404129%",
    y1: "34.9051932%",
    x2: "41.3597806%",
    y2: "71.1111885%",
    id: "linearGradient-65"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6280F6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3BD1",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.132432432,6.63497615 L4.50429253,13.9337043 L7.7672496,17.0324324 C7.7672496,17.0324324 8.48712242,15.7578696 8.39157393,14.4135135 L8.39157393,14.4135135 C8.29554849,13.0693164 6.18235294,9.51621622 6.18235294,8.17201908 L6.18235294,8.17201908 C6.18235294,6.82718601 9.35151033,3.65802862 9.35151033,3.65802862 L9.35151033,3.65802862 L4.50429253,0.10508744 L0.132432432,6.63497615 Z",
    id: "path-66"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "62.4920039%",
    y1: "60.7861485%",
    x2: "40.7097509%",
    y2: "30.5773204%",
    id: "linearGradient-68"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9BFCA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB99BA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.50461049,2.81383148 C2.21701113,4.61446741 0.127980922,6.48871224 0.127980922,6.48871224 L0.127980922,6.48871224 L1.49650238,8.64737679 C1.49650238,8.64737679 3.44101749,5.5508744 4.42496025,6.77535771 L4.42496025,6.77535771 C5.02686804,7.52337043 5.55691574,9.45516693 5.87758347,10.8438792 L5.87758347,10.8438792 C6.09888712,11.8 6.69030207,12.6287758 7.52829889,13.1387917 L7.52829889,13.1387917 C8.32559618,13.6248013 9.509062,14.3914149 11.1476948,15.5616852 L11.1476948,15.5616852 C14.6763116,18.082194 16.5248013,16.7136725 16.2370429,14.8895072 L16.2370429,14.8895072 C15.9488076,13.0651828 12.5693164,9.70890302 12.5693164,9.70890302 L12.5693164,9.70890302 C7.65294118,10.6265501 6.01096979,0.13290938 6.01096979,0.13290938 L6.01096979,0.13290938 C5.82162162,0.0583465819 5.62034976,0.0232114467 5.41351351,0.0232114467 L5.41351351,0.0232114467 C4.1799682,0.0232114467 2.75166932,1.2718601 2.50461049,2.81383148",
    id: "path-69"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "85.9909328%",
    y1: "42.6930759%",
    x2: "35.6272356%",
    y2: "56.8846577%",
    id: "linearGradient-71"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6280F6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3BD1",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.7570747,5.25596184 C15.6160572,17.9120827 14.5100159,28.1079491 12.9472178,36.2720191 L12.9472178,36.2720191 C8.4217806,59.899841 0.0561208267,66.5246423 0.0561208267,66.5246423 L0.0561208267,66.5246423 C1.20874404,69.8855326 6.96979332,72.0934817 6.96979332,72.0934817 L6.96979332,72.0934817 C12.5491256,66.4120827 17.118442,60.7351351 20.8575517,55.2007949 L20.8575517,55.2007949 C22.6944356,52.4837838 24.3308426,49.800159 25.7877583,47.1680445 L25.7877583,47.1680445 C28.5624801,42.1604134 30.6882353,37.3373609 32.3114467,32.8135135 L32.3114467,32.8135135 C33.2241653,30.2742448 33.9786963,27.8306836 34.6009539,25.500159 L34.6009539,25.500159 C38.6387917,10.3801272 37.1230525,0.0721780604 37.1230525,0.0721780604 L37.1230525,0.0721780604 C37.1230525,0.0721780604 29.7052464,2.87980922 15.7570747,5.25596184",
    id: "path-72"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "39.7208621%",
    y1: "68.1579903%",
    x2: "62.1218013%",
    y2: "9.35754098%",
    id: "linearGradient-74"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6280F6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3BD1",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.94069952,22.9987281 C9.96581876,37.9077901 26.0265501,45.181717 28.3313196,57.7136725 L28.3313196,57.7136725 C30.636089,70.245151 29.8717011,72.2620032 29.8717011,72.2620032 L29.8717011,72.2620032 C29.8717011,72.2620032 33.8050874,74.5667727 37.9823529,72.2620032 L37.9823529,72.2620032 C37.9823529,72.2620032 41.2146264,45.1011129 31.2588235,30.009062 L31.2588235,30.009062 C20.5526232,13.7802862 23.145787,2.68871224 23.145787,2.68871224 L23.145787,2.68871224 L3.91589825,0.0961844197 C3.91589825,0.0961844197 -4.08394277,8.09062003 2.94069952,22.9987281",
    id: "path-75"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "62.5643078%",
    y1: "73.481021%",
    x2: "44.1182255%",
    y2: "17.390807%",
    id: "linearGradient-77"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6280F6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3BD1",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.08219396,0.127980922 C8.08219396,0.127980922 10.3627981,0.872496025 10.218283,2.24101749 L10.218283,2.24101749 C10.0744038,3.60953895 5.82527822,4.68966614 1.79189189,2.16915739 L1.79189189,2.16915739 C0.783624801,3.03290938 0.0635930048,9.15468998 0.0635930048,9.15468998 L0.0635930048,9.15468998 L6.64626391,41.8526232 L13.5796502,44.3019078 C13.5796502,44.3019078 25.2713831,47.1826709 33.6254372,37.963752 L33.6254372,37.963752 C32.4732909,29.1769475 29.0165342,19.9585056 29.0165342,19.9585056 L29.0165342,19.9585056 L21.045787,7.3782194 L12.7872814,0.656120827 C12.7872814,0.656120827 10.8281399,0.107790143 8.7508744,0.107790143 L8.7508744,0.107790143 C8.52861685,0.107790143 8.30492846,0.113990461 8.08219396,0.127980922",
    id: "path-78"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "49.7856562%",
    cy: "38.0308987%",
    fx: "49.7856562%",
    fy: "38.0308987%",
    r: "65.4749749%",
    gradientTransform: "translate(0.497857,0.380309),scale(1.000000,0.752166),translate(-0.497857,-0.380309)",
    id: "radialGradient-80"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF2F2",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4E9FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.02209857,0.0957074722 C3.91780604,0.86391097 8.2899841,5.09395866 7.95389507,6.03131955 L7.95389507,6.03131955 C7.61796502,6.96868045 2.76836248,1.11096979 1.76009539,0.966613672 L1.76009539,0.966613672 C0.751987281,0.822734499 0.991891892,2.11923688 3.53672496,4.66391097 L3.53672496,4.66391097 C6.08139905,7.20874404 6.94562798,7.83195548 5.74531002,7.7836248 L5.74531002,7.7836248 C4.54483307,7.73593005 0.751987281,3.03131955 0.127503975,4.52019078 L0.127503975,4.52019078 C-0.496343402,6.00826709 4.73704293,8.02527822 4.8809221,9.46565978 L4.8809221,9.46565978 C4.95675676,10.2262321 3.88314785,9.61939587 2.83052464,9.01255962 L2.83052464,9.01255962 C1.88918919,8.46947536 0.965023847,7.92702703 0.895866455,8.36136725 L0.895866455,8.36136725 C0.703656598,9.5618442 2.3845787,11.2421304 6.41748808,12.154213 L6.41748808,12.154213 C10.4508744,13.0662957 13.1877583,14.2190779 14.8203498,15.6594595 L14.8203498,15.6594595 C15.8286169,13.690779 17.172973,12.154213 17.172973,12.154213 L17.172973,12.154213 C17.172973,12.154213 14.36407,10.4860095 14.7961844,7.10651828 L14.7961844,7.10651828 C15.2284579,3.72766296 14.7720191,1.35103339 13.6677266,2.74356121 L13.6677266,2.74356121 C12.563434,4.13577107 12.8995231,8.43593005 11.7473768,7.24610493 L11.7473768,7.24610493 C10.6526232,6.1163752 6.48839428,0.0440381558 5.20111288,0.0432421393 L5.20111288,0.0432421393 C5.13306836,0.0430842607 5.07313196,0.0600953895 5.02209857,0.0957074722",
    id: "path-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "39.9383279%",
    y1: "27.7963303%",
    x2: "65.2134601%",
    y2: "82.6895241%",
    id: "linearGradient-83"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9BFCA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB99BA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.142130366,6.07488076 C0.142130366,6.07488076 2.59077901,10.7650238 12.5306836,18.1917329 L12.5306836,18.1917329 C22.4696343,25.6176471 37.0174881,25.7473768 40.763752,34.9645469 L40.763752,34.9645469 C44.5077901,44.1841017 36.1537361,50.2340223 36.1537361,50.2340223 L36.1537361,50.2340223 C40.9065183,59.4529412 52.9589825,58.4448331 52.9589825,58.4448331 L52.9589825,58.4448331 C55.5416534,48.782035 55.8222576,40.7168521 54.899682,34.1195548 L54.899682,34.1195548 C52.5602544,17.4119237 42.490779,10.118283 42.490779,10.118283 L42.490779,10.118283 L42.9058824,6.57233704 L42.9228935,6.43465819 C42.8559618,6.46311606 42.7883943,6.4899841 42.7214626,6.51526232 L42.7214626,6.51526232 C41.8624801,6.86518283 41.0119237,7.17583466 40.1667727,7.44992051 L40.1667727,7.44992051 C19.8195548,14.072655 3.45612083,0.0591414944 3.45612083,0.0591414944 L3.45612083,0.0591414944 C-0.0984101749,3.2281399 0.142130366,6.07488076 0.142130366,6.07488076",
    id: "path-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "45.5599846%",
    y1: "21.3258517%",
    x2: "83.3331062%",
    y2: "101.215793%",
    id: "linearGradient-86"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F46682",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC449C",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.92686804,0.391573927 C1.32225755,0.525596184 0.69682035,0.70572337 0.0416534181,0.932432432 L0.0416534181,0.932432432 C0.0416534181,0.934022258 0.0432432432,0.935771065 0.0432432432,0.93736089 L0.0432432432,0.93736089 C0.0449920509,0.952782194 0.0548489666,0.994435612 0.0767885533,1.05500795 L0.0767885533,1.05500795 C0.122416534,1.18616852 0.221303657,1.39984102 0.424324324,1.5809221 L0.424324324,1.5809221 C0.478219396,1.62988871 0.53863275,1.67551669 0.609379968,1.71717011 L0.609379968,1.71717011 C0.611128776,1.71717011 0.614467409,1.71891892 0.616057234,1.71891892 L0.616057234,1.71891892 C0.680286169,1.73259141 1.19427663,1.85007949 2.06629571,2.24165342 L2.06629571,2.24165342 C2.38918919,2.38600954 2.76216216,2.57106518 3.17885533,2.80127186 L3.17885533,2.80127186 C6.57042925,4.67329094 12.8958665,9.63577107 19.526868,22.4127186 L19.526868,22.4127186 C19.6767886,22.7014308 19.8228935,22.9893482 19.9672496,23.273132 L19.9672496,23.273132 C23.0243243,29.3483307 24.6238474,34.5613672 25.3971383,38.8144674 L25.3971383,38.8144674 C25.4777424,39.2629571 25.5497615,39.700159 25.6139905,40.1252782 L25.6139905,40.1252782 C26.7717011,47.8774245 25.145151,52.0855326 25.145151,52.0855326 L25.145151,52.0855326 C25.145151,52.0855326 25.4607313,52.0014308 25.9534181,51.836725 L25.9534181,51.836725 C27.2806041,51.3880763 29.8957075,50.3480127 31.0499205,48.7713831 L31.0499205,48.7713831 C31.0499205,48.7713831 29.754531,30.6217806 21.8325914,17.3710652 L21.8325914,17.3710652 C21.8325914,17.3710652 24.5349762,17.2518283 28.1329094,16.5527822 L28.1329094,16.5527822 C31.8198728,15.836725 36.4480127,14.5111288 40.0761526,12.0794913 L40.0761526,12.0794913 C40.3721781,11.8828299 40.6610493,11.6775835 40.9416534,11.4643879 L40.9416534,11.4643879 L39.8631161,5.15039746 C39.8631161,5.15039746 40.1766296,3.87965024 39.6263911,4.3009539 L39.6263911,4.3009539 C37.4656598,5.95707472 31.209221,9.66550079 22.0243243,5.99062003 L22.0243243,5.99062003 C13.3672496,2.52750397 9.1645469,0.0750397456 4.71319555,0.0750397456 L4.71319555,0.0750397456 C3.80794913,0.0750397456 2.89220986,0.176470588 1.92686804,0.391573927",
    id: "path-87"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "48.2476699%",
    y1: "1.16065702%",
    x2: "72.2048956%",
    y2: "92.5565432%",
    id: "linearGradient-89"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F46682",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC449C",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.0416534181,0.614467409 C0.0416534181,0.614467409 0.128934817,1.11208267 0.609379968,1.39920509 L0.609379968,1.39920509 C0.609379968,1.39920509 9.73290938,3.22464229 19.526868,22.0947536 L19.526868,22.0947536 C19.6767886,22.3834658 19.8228935,22.6713831 19.9672496,22.9551669 L19.9672496,22.9551669 C17.6702703,14.5961844 20.4917329,9.99491256 20.4917329,9.99491256 L20.4917329,9.99491256 C15.9508744,9.87249603 5.16025437,2.38934817 1.92686804,0.073608903 L1.92686804,0.073608903 C1.32225755,0.207631161 0.69682035,0.387758347 0.0416534181,0.614467409",
    id: "path-90"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "66.891599%",
    y1: "51.6686805%",
    x2: "5.00295638%",
    y2: "-4.5683884%",
    id: "linearGradient-92"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0056FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.10317965,1.09062003 C1.26788553,3.22464229 4.39189189,10.1316375 2.59523052,20.1596184 L2.59523052,20.1596184 C2.59523052,20.1596184 11.8300477,18.4149444 14.8344992,27.7602544 L14.8344992,27.7602544 L14.836089,27.7602544 C12.4966614,11.0526232 2.42718601,3.75898251 2.42718601,3.75898251 L2.42718601,3.75898251 L2.84228935,0.213036566 L2.65786963,0.155961844 C1.79888712,0.505882353 0.948330684,0.816534181 0.10317965,1.09062003",
    id: "path-93"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.4144602%",
    y1: "59.1561046%",
    x2: "42.3590184%",
    y2: "-2.07045994%",
    id: "linearGradient-95"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0056FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.079491256,0.453418124 L0.234340223,1.61494436 L0.83736089,6.14372019 C0.83736089,6.14372019 3.35850556,8.32861685 7.22337043,7.75214626 L7.22337043,7.75214626 C11.0887122,7.17551669 9.62511924,5.06343402 9.62511924,5.06343402 L9.62511924,5.06343402 C9.62511924,5.06343402 8.71255962,4.63131955 7.12766296,4.10190779 L7.12766296,4.10190779 C6.90429253,3.98600954 6.73449921,3.74721781 6.60826709,3.44356121 L6.60826709,3.44356121 C6.11128776,2.24864865 6.26391097,0.0217806041 6.26391097,0.0217806041 L6.26391097,0.0217806041 L0.079491256,0.453418124 Z",
    id: "path-96"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "76.48691%",
    y1: "44.5446755%",
    x2: "15.2262198%",
    y2: "55.0734286%",
    id: "linearGradient-98"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9BFCA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB99BA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.0561208267,7.79570747 L1.40047695,13.8895072 C1.40047695,13.8895072 1.78473768,14.3694754 5.145469,14.5852146 L5.145469,14.5852146 C10.8011129,15.0157393 17.5330684,14.1772655 17.0531002,12.0647059 L17.0531002,12.0647059 C16.573132,9.95214626 13.0680445,3.61399046 13.0680445,3.61399046 L13.0680445,3.61399046 L11.963593,0.541017488 L8.56661367,0.0610492846 L0.0561208267,7.79570747 Z",
    id: "path-99"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "93.1451705%",
    y1: "35.4292297%",
    x2: "33.9070969%",
    y2: "67.8053748%",
    id: "linearGradient-101"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9BFCA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB99BA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.96216216,1.0200318 C6.14896661,1.28696343 5.42146264,1.60651828 4.77233704,1.96772655 L4.77233704,1.96772655 C-3.663593,6.66788553 1.16438792,18.7538951 4.44117647,23.636407 L4.44117647,23.636407 C7.97042925,28.8926868 9.19554849,33.3578696 10.1313196,38.1842607 L10.1313196,38.1842607 C11.0677266,43.008903 15.4624801,46.827027 22.7588235,47.2104928 L22.7588235,47.2104928 C30.0575517,47.5953895 32.0739269,50.9561208 34.3798092,56.2383148 L34.3798092,56.2383148 C36.6839428,61.518283 44.4861685,60.8713831 48.5920509,59.2866455 L48.5920509,59.2866455 C52.6974563,57.7017488 56.6413355,58.3502385 56.6413355,58.3502385 L56.6413355,58.3502385 L55.7220986,53.309221 C55.7220986,53.309221 54.0653418,49.2756757 49.9600954,49.2033386 L49.9600954,49.2033386 C45.8540541,49.1313196 43.6949126,47.9062003 42.6141494,44.5213037 L42.6141494,44.5213037 C41.5333863,41.1368839 38.7958665,39.0480127 32.6742448,37.1759936 L32.6742448,37.1759936 C26.5534181,35.3023847 25.6879173,33.7190779 25.545151,28.0289348 L25.545151,28.0289348 C25.4007949,22.3387917 24.1756757,20.1779014 21.1510334,18.4502385 L21.1510334,18.4502385 C18.1257552,16.7209857 20.791256,11.9682035 20.7187599,8.79920509 L20.7187599,8.79920509 C20.6591415,6.190938 19.0899841,0.0721780604 12.1944356,0.0728139905 L12.1944356,0.0728139905 C10.7101749,0.0728139905 8.97806041,0.356756757 6.96216216,1.0200318",
    id: "path-102"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "40.7961832%",
    y1: "6.59949947%",
    x2: "57.356535%",
    y2: "99.2132696%",
    id: "linearGradient-104"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#873B50",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F2649",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.44117647,21.7286169 C7.97042925,26.9848967 9.19554849,31.4500795 10.1313196,36.2764706 L10.1313196,36.2764706 C11.0677266,41.1011129 15.4624801,44.9192369 22.7588235,45.3027027 L22.7588235,45.3027027 C30.0575517,45.6875994 32.0739269,49.0483307 34.3798092,54.3305246 L34.3798092,54.3305246 C36.6839428,59.6104928 44.4861685,58.963593 48.5920509,57.3788553 L48.5920509,57.3788553 C52.6974563,55.7939587 56.6413355,56.4424483 56.6413355,56.4424483 L56.6413355,56.4424483 C56.6413355,56.4424483 51.5678855,52.8883943 45.8073132,54.0410175 L45.8073132,54.0410175 C40.0446741,55.1942766 36.6839428,52.5050874 35.3391097,48.663434 L35.3391097,48.663434 C33.9949126,44.8220986 28.5214626,39.9248013 23.6243243,39.7332273 L23.6243243,39.7332273 C18.7259141,39.5416534 13.5414944,35.508744 13.1565978,28.7866455 L13.1565978,28.7866455 C12.7732909,22.0647059 11.2356121,18.99062 7.87488076,16.4936407 L7.87488076,16.4936407 C5.0936407,14.4282989 1.91573927,5.51796502 4.77233704,0.059936407 L4.77233704,0.059936407 C-3.663593,4.76009539 1.16438792,16.8461049 4.44117647,21.7286169",
    id: "path-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "14.1608085%",
    y1: "72.6836248%",
    x2: "47.7939679%",
    y2: "51.9832354%",
    id: "linearGradient-107"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#873B50",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F2649",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.07647059,0.385055644 C-0.435930048,1.39332273 -0.940063593,7.80333863 3.95771065,6.65071542 L3.95771065,6.65071542 C3.52559618,3.62607313 3.95771065,1.46518283 3.95771065,1.46518283 L3.95771065,1.46518283 C3.95771065,1.46518283 3.06963434,0.110015898 1.93354531,0.110015898 L1.93354531,0.110015898 C1.65930048,0.110015898 1.37058824,0.189030207 1.07647059,0.385055644",
    id: "path-108"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "51.8403895%",
    y1: "-12.9575761%",
    x2: "49.9362784%",
    y2: "75.4678613%",
    id: "linearGradient-110"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0056FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.35103339,3.02082671 C8.27074722,3.02082671 1.42845787,2.58871224 0.276470588,6.1899841 L0.276470588,6.1899841 C-0.876152623,9.79109698 2.65310016,12.1678855 2.22098569,14.2562798 L2.22098569,14.2562798 C1.78871224,16.345151 3.1572337,22.2507154 9.27901431,19.5136725 L9.27901431,19.5136725 C9.27901431,19.5136725 5.31812401,18.7219396 6.68664547,16.0569157 L6.68664547,16.0569157 C7.48934817,14.4923688 8.36740859,15.1869634 9.33402226,15.881717 L9.33402226,15.881717 C10.0143084,16.3704293 10.7386328,16.8586645 11.5119237,16.5610493 L11.5119237,16.5610493 C12.9523052,14.400159 14.3448331,10.1992051 14.0807631,6.14165342 L14.0807631,6.14165342 C14.0807631,6.14165342 16.4332273,7.15039746 17.2015898,8.54244833 L17.2015898,8.54244833 C17.2015898,8.54244833 17.9939587,1.94069952 14.6809221,0.355802862 L14.6809221,0.355802862 C14.1604134,0.106995231 13.6984102,0.00206677265 13.2853736,0.00206677265 L13.2853736,0.00206677265 C11.0694754,0.00206677265 10.2613672,3.02082671 9.35103339,3.02082671",
    id: "path-111"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "44.5486225%",
    y1: "-1.39715677%",
    x2: "56.2893432%",
    y2: "73.6319126%",
    id: "linearGradient-113"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#873B50",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F2649",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.85659777,0.108903021 C3.88521463,0.533863275 1.57281399,1.53720191 0.808267091,1.78982512 L0.808267091,1.78982512 C-0.16899841,2.1127186 -0.110333863,3.95071542 1.00381558,3.86947536 L1.00381558,3.86947536 C1.00381558,3.86947536 -0.37281399,5.28680445 1.05612083,5.78759936 L1.05612083,5.78759936 C1.05612083,5.78759936 0.43608903,7.47281399 1.52337043,8.11144674 L1.52337043,8.11144674 C1.52337043,8.11144674 0.26963434,9.03354531 1.74960254,9.67440382 L1.74960254,9.67440382 C3.22957075,10.3152623 6.52209857,9.08950715 6.71224165,7.80190779 L6.71224165,7.80190779 C6.9027027,6.51462639 6.07567568,6.59427663 6.07567568,6.59427663 L6.07567568,6.59427663 C6.07567568,6.59427663 6.73577107,5.23243243 5.81764706,4.42400636 L5.81764706,4.42400636 C5.81764706,4.42400636 6.7254372,3.30222576 5.76979332,2.13577107 L5.76979332,2.13577107 C5.76979332,2.13577107 6.67154213,1.12368839 5.80222576,0.276947536 L5.80222576,0.276947536 C5.63990461,0.118600954 5.42448331,0.0359300477 5.20556439,0.0359300477 L5.20556439,0.0359300477 C5.08759936,0.0359300477 4.96868045,0.0597774245 4.85659777,0.108903021",
    id: "path-114"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "47.5602136%",
    y1: "11.5526%",
    x2: "52.0167208%",
    y2: "85.6734392%",
    id: "linearGradient-116"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9BFCA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB99BA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.82034976,5.56565978 C-0.404610493,5.46693164 -0.212400636,8.11319555 0.411287758,9.07313196 L0.411287758,9.07313196 C1.03577107,10.0335453 10.7346582,9.07313196 10.7346582,9.07313196 L10.7346582,9.07313196 L12.463434,7.00890302 L13.6154213,8.49697933 L17.9372019,8.20937997 C19.1853736,4.94419714 17.9372019,1.63116057 17.9372019,1.63116057 L17.9372019,1.63116057 C17.9372019,1.63116057 14.7680445,1.00683625 12.6071542,0.046899841 L12.6071542,0.046899841 C12.2712242,3.59984102 8.04610493,5.6645469 3.82034976,5.56565978",
    id: "path-117"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "32.7129209%",
    y1: "40.9827648%",
    x2: "60.8680898%",
    y2: "58.9124493%",
    id: "linearGradient-119"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0056FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.2581876,7.4709062 C4.2581876,7.4709062 2.52941176,7.43465819 2.20540541,8.83942766 L2.20540541,8.83942766 C2.20540541,8.83942766 0.621144674,8.80317965 0.765023847,10.6756757 L0.765023847,10.6756757 C0.765023847,10.6756757 -0.279332273,11.1798092 0.0807631161,12.6564388 L0.0807631161,12.6564388 C0.441017488,14.1325914 1.66518283,16.2933227 3.24992051,16.9775835 L3.24992051,16.9775835 C4.83418124,17.6618442 5.95055644,18.9220986 6.09443561,19.4624801 L6.09443561,19.4624801 C7.1027027,19.0666137 10.5238474,17.6262321 10.5238474,17.6262321 L10.5238474,17.6262321 C10.5238474,17.6262321 8.91764706,13.5926868 8.92861685,10.6400636 L8.92861685,10.6400636 C8.93958665,7.68680445 1.80953895,0.0526232114 1.08903021,0.0526232114 L1.08903021,0.0526232114 C0.369157393,0.0526232114 4.2581876,7.4709062 4.2581876,7.4709062",
    id: "path-120"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.0012118%",
    y1: "13.3573094%",
    x2: "50.0012118%",
    y2: "82.1268324%",
    id: "linearGradient-122"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9BFCA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB99BA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.58394277,0.219872814 L0.609220986,2.30937997 C0.150079491,2.55039746 -0.0224165342,3.12098569 0.225755167,3.57694754 L0.225755167,3.57694754 L1.07042925,5.12480127 L6.61621622,2.02829889 L5.83100159,0.59554849 C5.66200318,0.287917329 5.34403816,0.113195548 5.0154213,0.113195548 L5.0154213,0.113195548 C4.86947536,0.113195548 4.7217806,0.147535771 4.58394277,0.219872814",
    id: "path-123"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.00133393642%",
    y1: "50.0004213%",
    x2: "99.9999655%",
    y2: "50.0004213%",
    id: "linearGradient-125"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF2F2",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4E9FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.38775835,3.27631161 C1.38775835,3.27631161 -3.53783784,21.3166932 5.41240064,46.7775835 L5.41240064,46.7775835 L15.7561208,46.5589825 L25.8756757,46.0319555 C25.6971383,39.1122417 25.3540541,22.0844197 25.9618442,11.6793323 L25.9618442,11.6793323 C20.6896661,1.40381558 16.8006359,0.107790143 16.8006359,0.107790143 L16.8006359,0.107790143 L1.38775835,3.27631161 Z",
    id: "path-126"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "41.5740014%",
    y1: "84.2437404%",
    x2: "56.2936447%",
    y2: "33.4956994%",
    id: "linearGradient-128"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F5B9A",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17386B",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.13418124,4.84308426 C0.13418124,4.84308426 15.2586645,39.8936407 28.2227345,45.2236884 L28.2227345,45.2236884 L37.681717,28.3220986 L35.0885533,25.9926868 C35.0885533,25.9926868 15.4030207,17.9993641 7.48060413,0.138155803 L7.48060413,0.138155803 C7.48060413,0.138155803 1.28616852,1.67408585 0.13418124,4.84308426",
    id: "path-129"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.000100900184%",
    y1: "49.9993416%",
    x2: "99.9998472%",
    y2: "49.9993416%",
    id: "linearGradient-131"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E7EE4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B2FBF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.58807631,0.125914149 L0.0979332273,27.3500795 L0.817806041,38.4416534 C0.817806041,38.4416534 11.7496025,46.36407 22.2007949,41.75469 L22.2007949,41.75469 L21.2468998,0.125914149 L7.58807631,0.125914149 Z",
    id: "path-132"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "47.3925169%",
    cy: "45.9866293%",
    fx: "47.3925169%",
    fy: "45.9866293%",
    r: "77.4358713%",
    gradientTransform: "translate(0.473925,0.459866),scale(1.000000,0.513187),translate(-0.473925,-0.459866)",
    id: "radialGradient-134"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF2F2",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4E9FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.8713831,0.125596184 C12.8713831,0.125596184 6.53259141,4.35055644 3.84356121,15.5866455 L3.84356121,15.5866455 C1.15484897,26.8203498 4.90063593,41.609221 0.09936407,45.0661367 L0.09936407,45.0661367 L5.95596184,51.309221 C5.95596184,51.309221 7.84833068,47.7146264 8.56613672,39.8761526 L8.56613672,39.8761526 C8.74244833,37.9591415 8.84833068,35.7861685 8.83847377,33.3507154 L8.83847377,33.3507154 C8.74069952,9.91939587 14.6357711,4.35055644 14.6357711,4.35055644 L14.6357711,4.35055644 L15.1519873,2.0782194 C15.1519873,2.07662957 15.1535771,2.07662957 15.1535771,2.07662957 L15.1535771,2.07662957 L15.6071542,0.0766295707 L12.8713831,0.125596184 Z",
    id: "path-135"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.00150168129%",
    y1: "49.999817%",
    x2: "100.001399%",
    y2: "49.999817%",
    id: "linearGradient-137"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E7EE4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B2FBF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.386009539,2.16756757 C0.386009539,2.16756757 1.39427663,2.45643879 1.10715421,12.3952305 L1.10715421,12.3952305 C0.922098569,18.7828299 0.379491256,30.6992051 0.192686804,40.6710652 L0.192686804,40.6710652 C0.0883942766,46.2168521 0.0939586645,51.1613672 0.330683625,54.2162162 L0.330683625,54.2162162 C2.05007949,60.0744038 9.46057234,59.208903 16.3995231,55.5604134 L16.3995231,55.5604134 C23.3384738,51.9109698 30.4926868,54.0244833 30.4926868,54.0244833 L30.4926868,54.0244833 C30.4926868,54.0244833 27.9952305,49.2216216 22.9046105,38.9473768 L22.9046105,38.9473768 C17.8163752,28.672337 20.7926868,11.290938 17.2397456,7.25739269 L17.2397456,7.25739269 C14.5193959,4.16915739 6.04610493,1.59920509 2.22798092,0.566295707 L2.22798092,0.566295707 C1.06152623,0.251669316 0.330683625,0.0785373609 0.330683625,0.0785373609 L0.330683625,0.0785373609 L0.386009539,2.16756757 Z",
    id: "path-138"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "35.5425043%",
    y1: "7.86457731%",
    x2: "52.0990083%",
    y2: "92.2521983%",
    id: "linearGradient-140"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E7EE4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B2FBF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.13481717,1.85023847 C1.43354531,5.44769475 8.34228935,7.75961844 8.34228935,7.75961844 L8.34228935,7.75961844 C9.35039746,7.39936407 9.96057234,5.68982512 9.96057234,5.68982512 L9.96057234,5.68982512 C4.06883943,5.38282989 1.65930048,0.0117647059 1.65930048,0.0117647059 L1.65930048,0.0117647059 C-0.0694753577,0.621780604 0.13481717,1.85023847 0.13481717,1.85023847",
    id: "path-141"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "56.8587929%",
    y1: "41.1136176%",
    x2: "41.4776275%",
    y2: "56.9840147%",
    id: "linearGradient-143"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF2F2",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4E9FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-144",
    points: "0.0275039746 2.77933227 0.603497615 8.01319555 5.11685215 6.76502385 6.26899841 4.07583466 6.17281399 0.522893482 2.57217806 0.138473768"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "27.5518251%",
    y1: "60.0150533%",
    x2: "69.5965408%",
    y2: "34.4063527%",
    id: "linearGradient-146"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9BFCA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB99BA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.0104928458,1.13465819 L0.449761526,2.98791733 C0.540858506,3.37027027 0.831319555,3.67392687 1.20969793,3.78044515 L1.20969793,3.78044515 L1.80667727,3.94848967 C2.21144674,4.06263911 2.64531002,3.93259141 2.92034976,3.61462639 L2.92034976,3.61462639 L4.00604134,2.35930048 L2.90158983,0.0545310016 L0.0104928458,1.13465819 Z",
    id: "path-147"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-0.0042121598%",
    y1: "50.0002288%",
    x2: "100.002155%",
    y2: "50.0002288%",
    id: "linearGradient-149"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0056FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.0399046105,2.59825119 L0.904292528,7.2554849 L5.3518283,1.95580286 L5.34960254,1.94085851 C5.25786963,1.26327504 4.93513514,0.638314785 4.43593005,0.17154213 L4.43593005,0.17154213 L4.36120827,0.10127186 L0.0399046105,2.59825119 Z",
    id: "path-150"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.00431401891%",
    y1: "50.00046%",
    x2: "99.9986244%",
    y2: "50.00046%",
    id: "linearGradient-152"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F5B9A",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17386B",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-153",
    points: "1.64689984 0.749284579 0.0626391097 6.46248013 3.8554849 3.87011129 3.18346582 0.124960254"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-0.00186653812%",
    y1: "50.0006858%",
    x2: "100.006098%",
    y2: "50.0006858%",
    id: "linearGradient-155"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F5B9A",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17386B",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.135135135,0.0756756757 C0.135135135,0.0756756757 2.0554849,4.20524642 1.67154213,7.56597774 L1.67154213,7.56597774 C1.2872814,10.927186 2.39141494,12.6558029 6.52114467,11.3109698 L6.52114467,11.3109698 C10.6500795,9.96677266 10.9982512,8.08203498 10.9982512,8.08203498 L10.9982512,8.08203498 C14.1310016,9.73879173 15.4995231,6.31764706 15.4995231,6.31764706 L15.4995231,6.31764706 L16.0036566,5.41764706 L14.5874404,2.04435612 L8.24976153,0.0756756757 L0.135135135,0.0756756757 Z",
    id: "path-156"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "10.7937195%",
    y1: "49.7202338%",
    x2: "75.8479346%",
    y2: "50.3891139%",
    id: "linearGradient-158"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9BFCA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB99BA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.306677266,9.29157393 C2.1073132,17.2139905 8.3009539,16.2777424 13.4146264,15.7736089 L13.4146264,15.7736089 C18.5281399,15.2694754 17.3399046,20.8510334 17.3399046,20.8510334 L17.3399046,20.8510334 C17.3399046,20.8510334 18.600159,19.3025437 19.7527822,19.3387917 L19.7527822,19.3387917 C20.9049285,19.3744038 20.9049285,21.1030207 20.9049285,21.1030207 L20.9049285,21.1030207 C25.2985692,20.3826709 24.8664547,16.4936407 23.4260731,15.7736089 L23.4260731,15.7736089 C21.9856916,15.0532591 21.3370429,14.3332273 21.9856916,11.4519873 L21.9856916,11.4519873 C22.6335453,8.57122417 20.3289348,6.84292528 16.3678855,8.21081081 L16.3678855,8.21081081 C12.4063593,9.57933227 14.4233704,6.62670906 11.1104928,2.08918919 L11.1104928,2.08918919 C10.1381558,0.757710652 8.65135135,0.145786963 7.08076312,0.145786963 L7.08076312,0.145786963 C3.29968203,0.145786963 -0.96518283,3.69411765 0.306677266,9.29157393",
    id: "path-159"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "55.4545064%",
    y1: "13.3106731%",
    x2: "48.355552%",
    y2: "69.3201664%",
    id: "linearGradient-161"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F5B9A",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17386B",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-162",
    points: "0.00699523052 0.0500794913 0.00699523052 130.72814 65.3465819 130.72814 65.3356121 104.607154 130.685533 0.0500794913"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-164",
    points: "0.0319554849 42.6279809 27.3807631 86.6899841 100.319873 86.6899841 46.317965 0.0777424483"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5227345,0.0933227345 C1.62321145,0.0933227345 0.0841017488,1.63259141 0.0841017488,3.53211447 L0.0841017488,3.53211447 L0.0841017488,40.645151 C0.0841017488,47.2195548 2.69523052,53.5236884 7.34372019,58.1720191 L7.34372019,58.1720191 C11.9922099,62.8206677 18.2968203,65.4322734 24.8705882,65.4322734 L24.8705882,65.4322734 L61.9842607,65.4322734 C63.8831479,65.4322734 65.4230525,63.8925278 65.4230525,61.9930048 L65.4230525,61.9930048 L65.4230525,24.8799682 C65.4230525,18.3062003 62.8112878,12.0014308 58.1627981,7.35294118 L58.1627981,7.35294118 C53.5143084,2.70445151 47.2101749,0.0933227345 40.63593,0.0933227345 L40.63593,0.0933227345 L3.5227345,0.0933227345 Z",
    id: "path-166"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-168",
    points: "0.10508744 0.00747217806 0.10508744 9.60206677 10.8337043 9.60206677 10.8337043 39.5147854 21.2864865 39.5147854 21.2864865 9.60206677 32.0151033 9.60206677 32.0151033 0.00747217806"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-170",
    points: "1.57217806 1.34801272 0.0340222576 2.64435612 0.745627981 5.42686804 3.23926868 3.32480127 5.73243243 1.22321145 3.11081081 0.0508744038"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "25.1023235%",
    y1: "19.2208467%",
    x2: "63.0191775%",
    y2: "68.5060196%",
    id: "linearGradient-172"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC33",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7B60",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.76375199,2.39062003 C-2.00651828,7.25437202 -0.833068362,18.1394277 6.38489666,26.7022258 L6.38489666,26.7022258 C13.6028617,35.2655008 24.1319555,38.263752 29.9023847,33.3995231 L29.9023847,33.3995231 C35.6732909,28.5351351 34.499682,17.6507154 27.281876,9.08791733 L27.281876,9.08791733 C22.4076312,3.30524642 16.0241653,0.060572337 10.6149444,0.060572337 L10.6149444,0.060572337 C8.01399046,0.060572337 5.63767886,0.811128776 3.76375199,2.39062003",
    id: "path-173"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "47.697653%",
    y1: "13.4959032%",
    x2: "53.7599419%",
    y2: "109.608542%",
    id: "linearGradient-175"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC33",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7B60",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.0149444,2.25771065 C24.7343402,5.86375199 28.0042925,12.8435612 25.3187599,17.8475358 C22.6332273,22.8515103 15.009221,23.9848967 8.2899841,20.3788553 C1.57058824,16.772814 -1.69936407,9.79300477 0.986168521,4.78903021",
    id: "path-176"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "42.6465036%",
    y1: "68.7427808%",
    x2: "61.7347328%",
    y2: "20.0905067%",
    id: "linearGradient-178"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBF57",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC672",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.9235294,2.03688394 C19.3841017,4.96756757 22.2806041,10.1942766 20.3931638,13.7114467 C18.5055644,17.2284579 12.5488076,17.7038156 7.08823529,14.7734499 C1.62766296,11.8429253 -1.26883943,6.61605723 0.618600954,3.0990461",
    id: "path-179"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "44.3619512%",
    y1: "58.6908717%",
    x2: "82.9996837%",
    y2: "-0.866471196%",
    id: "linearGradient-181"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE8CA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBD1",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-182",
    points: "0.0542130366 0.275834658 1.70492846 3.08791733 3.35612083 5.9 4.95421304 3.51351351 3.9354531 1.7782194 2.9163752 0.0429252782"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "74.1207963%",
    y1: "22.7076958%",
    x2: "30.8585911%",
    y2: "58.3497856%",
    id: "linearGradient-184"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87E8FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34BFE9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.9691574,3.84880763 C2.31128776,9.51923688 -2.4200318,19.3917329 1.40143084,25.900159 L1.40143084,25.900159 C5.22241653,32.4085851 16.1491256,33.0879173 25.8068362,27.4174881 L25.8068362,27.4174881 C35.4645469,21.7470588 40.1960254,11.8745628 36.3745628,5.36613672 L36.3745628,5.36613672 C34.2922099,1.81923688 30.0988871,0.00333863275 25.1510334,0.00333863275 L25.1510334,0.00333863275 C21.0201908,0.00333863275 16.363434,1.26868045 11.9691574,3.84880763",
    id: "path-185"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "56.799404%",
    y1: "18.9270366%",
    x2: "43.5264319%",
    y2: "79.5839793%",
    id: "linearGradient-187"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87E8FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34BFE9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.2782194,0.318124006 C19.8149444,-0.844197138 26.6262321,2.76343402 27.4920509,8.37631161 C28.3575517,13.9890302 22.9497615,19.4812401 15.4130366,20.6437202 C7.87647059,21.8060413 1.06502385,18.1984102 0.199523052,12.5856916",
    id: "path-188"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.6247452%",
    y1: "68.9971846%",
    x2: "50.6733134%",
    y2: "15.9100841%",
    id: "linearGradient-190"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1F2FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAF4FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.1562798,0.27154213 C16.2810811,-0.673131955 21.7394277,1.75898251 22.3478537,5.70397456 C22.9564388,9.64880763 18.4844197,13.6127186 12.3594595,14.5572337 C6.23481717,15.5019078 0.776311606,13.0696343 0.168044515,9.12496025",
    id: "path-191"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.7907032%",
    y1: "57.4504627%",
    x2: "50.2215028%",
    y2: "42.1163259%",
    id: "linearGradient-193"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1F2FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAF4FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-194",
    points: "1.22257552 1.66963434 0.0782193959 3.32480127 1.49554849 5.8227345 3.34992051 3.14022258 5.20445151 0.458187599 2.36709062 0.0144674086"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "24.9936931%",
    y1: "21.2099516%",
    x2: "68.5446628%",
    y2: "60.9068837%",
    id: "linearGradient-196"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0056FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.85405405,4.66899841 C-2.43799682,10.8771065 1.55039746,21.072337 10.7627981,27.4411765 L10.7627981,27.4411765 C19.9747218,33.8101749 30.9217806,33.9408585 35.2138315,27.7329094 L35.2138315,27.7329094 C39.5058824,21.5254372 35.5170111,11.3295707 26.3050874,4.96057234 L26.3050874,4.96057234 C21.6216216,1.72241653 16.49062,0.0972972973 12.0127186,0.0972972973 L12.0127186,0.0972972973 C7.68314785,0.0972972973 3.96406995,1.61748808 1.85405405,4.66899841",
    id: "path-197"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "45.8947549%",
    y1: "16.2022371%",
    x2: "53.9094908%",
    y2: "82.1783366%",
    id: "linearGradient-199"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0056FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.296979332,1.06979332 C0.296979332,1.06979332 1.01748808,3.08616852 0.333227345,4.63465819 L0.333227345,4.63465819 C-0.351033386,6.18330684 0.945468998,7.11955485 1.84562798,7.55166932 L1.84562798,7.55166932 C2.74610493,7.98394277 2.57806041,10.1683625 3.69459459,10.2046105 L3.69459459,10.2046105 C4.81096979,10.2403816 4.90651828,8.88394277 4.90651828,8.88394277 L4.90651828,8.88394277 C6.52702703,8.88394277 6.45516693,7.73195548 6.45516693,7.73195548 L6.45516693,7.73195548 C7.85977742,7.76756757 7.78775835,6.65119237 7.78775835,6.65119237 L7.78775835,6.65119237 C8.75977742,6.36343402 8.39952305,4.52718601 8.14753577,3.87853736 L8.14753577,3.87853736 C7.89554849,3.23052464 5.4227345,0.073608903 5.4227345,0.073608903 L5.4227345,0.073608903 L0.296979332,1.06979332 Z",
    id: "path-200"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "91.1920645%",
    y1: "35.7219652%",
    x2: "33.0603142%",
    y2: "54.67815%",
    id: "linearGradient-202"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9BFCA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB99BA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.216057234,1.70524642 C-0.16836248,3.33720191 0.792050874,4.29761526 0.792050874,4.29761526 L0.792050874,4.29761526 C3.91287758,4.87376789 6.88966614,2.90492846 6.88966614,2.90492846 L6.88966614,2.90492846 C7.03418124,1.84896661 6.02591415,0.0241653418 6.02591415,0.0241653418 L6.02591415,0.0241653418 C6.02591415,0.0241653418 1.41653418,1.03243243 0.216057234,1.70524642",
    id: "path-203"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "106.278302%",
    y1: "35.850567%",
    x2: "40.9351149%",
    y2: "54.0397146%",
    id: "linearGradient-205"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF2F2",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4E9FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.09523052,1.2936407 C-1.19030207,5.11780604 -2.05786963,14.4977742 11.9863275,24.8155803 L11.9863275,24.8155803 C22.9499205,32.8709062 26.4863275,45.7745628 26.4863275,45.7745628 L26.4863275,45.7745628 C26.4863275,45.7745628 33.0403816,46.427504 34.9130366,42.9707472 L34.9130366,42.9707472 C34.9130366,42.9707472 31.1677266,23.6683625 23.24531,13.1534181 L23.24531,13.1534181 C17.0550079,4.93688394 9.50158983,0.135771065 5.02877583,0.135771065 L5.02877583,0.135771065 C3.7772655,0.135771065 2.76709062,0.511605723 2.09523052,1.2936407",
    id: "path-206"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "20.4008182%",
    y1: "50.4237879%",
    x2: "61.757595%",
    y2: "49.7932313%",
    id: "linearGradient-208"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E7EE4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B2FBF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.244356121,0.0917329094 C-1.66279809,9.65882353 8.3936407,21.6503975 18.8607313,25.9715421 L18.8607313,25.9715421 C29.3279809,30.2928458 29.0397456,35.7666137 29.0397456,35.7666137 L29.0397456,35.7666137 L37.4903021,38.6473768 L40.2750397,28.9484897 C35.7616852,20.1139905 28.6558029,19.2496025 16.0755167,15.0244833 L16.0755167,15.0244833 C3.49586645,10.7988871 1.91160572,0.0917329094 1.91160572,0.0917329094 L1.91160572,0.0917329094 L0.244356121,0.0917329094 Z",
    id: "path-209"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.000121321113%",
    y1: "50.0001901%",
    x2: "100.000706%",
    y2: "50.0001901%",
    id: "linearGradient-211"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0056FF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Get-Started",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-289-Copy"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(28.810811, 79.034976)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.450079,7.92734499 C93.8491256,12.2842607 55.7750397,20.0936407 47.1397456,44.7807631 L47.1397456,44.7807631 C41.6890302,60.363275 50.9446741,74.1570747 40.3950715,86.5747218 L40.3950715,86.5747218 C30.53593,98.1798092 16.2972973,93.3786963 6.30620032,107.595231 L6.30620032,107.595231 C5.48298887,108.766137 -0.645945946,117.747854 0.0624801272,129.5 L0.0624801272,129.5 C1.20302067,148.411288 18.7036566,152.191097 23.1098569,170.841017 L23.1098569,170.841017 C27.4491256,189.209698 13.1704293,196.96407 16.6278219,208.436248 L16.6278219,208.436248 C20.1308426,220.061049 40.5791733,236.127822 155.593323,232.557234 L155.593323,232.557234 C272.141335,228.938315 296.127822,206.374722 310.839905,190.304134 L310.839905,190.304134 C337.872337,160.775199 313.334658,121.700636 306.527981,107.215898 L306.527981,107.215898 C291.96089,76.218601 310.839905,65.772814 303.445628,39.9702703 L303.445628,39.9702703 C294.857393,10.000318 247.913514,0.112718601 198.127981,0.112718601 L198.127981,0.112718601 C169.610016,0.112718601 140.162162,3.35612083 116.450079,7.92734499",
    id: "Fill-1",
    fill: "url(#linearGradient-5)",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-53",
    strokeWidth: 1,
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(45.081081, 0.821940)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M436.844204,0.684 L436.844204,22.946717 C50.6577566,13.3915472 45.0613446,338.355396 44.9810654,347.775849 L0.223602491,347.810038 C23.8252309,-27.9842264 436.844204,0.684 436.844204,0.684",
    id: "Fill-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(140.081081, 47.821940)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-7",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.844092,0.645678947 L341.844092,24.3298526 C22.0309728,11.5249053 53.5784871,294.349937 54.3546251,300.919658 L0.159766423,300.963111 C-0.0698978102,291.038711 -4.35000398,-14.4149579 341.844092,0.645678947",
    id: "Fill-7",
    mask: "url(#mask-7)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(193.081081, 71.821940)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-9",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.844035,0.566210612 L288.844035,24.6853355 C-4.44101964,5.67047265 49.8033496,276.883095 49.8033496,276.883095 L1.25089552,276.919727 C0.474477612,270.355618 -31.0844132,-12.2277976 288.844035,0.566210612",
    id: "Fill-10",
    mask: "url(#mask-9)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(90.081081, 23.821940)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-11",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-10"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.844243,0.30487126 L391.844243,24.6188065 C45.9862024,9.56816284 50.2621538,314.819154 50.4915951,324.736969 L0.0791255061,324.776096 C0.159384615,315.366023 5.75439676,-9.23977035 391.844243,0.30487126",
    id: "Fill-13",
    mask: "url(#mask-11)"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-16",
    fill: "#FFA81D",
    points: "208.901316 25.0419011 213.276723 27.8219396 212.941496 22.8366394 217.081081 19.7485665 211.979116 18.5104668 210.161675 13.8219396 207.343908 18.0419011 202.081081 18.2324629 205.441729 22.0785876 204.006307 26.8848083"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-18",
    fill: "#FFA81D",
    points: "93.0764004 65.7800929 98.0810811 66.253364 95.3961465 61.8125578 97.3733619 56.9827774 92.5037388 58.2802091 88.7207955 54.8219396 88.3962576 60.0643807 84.0810811 62.7567777 88.7501172 64.6995579 89.8661188 69.8219396"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-20",
    fill: "#FFA81D",
    points: "36.9801838 106.823098 41.0810811 105.886529 37.8625268 103.115052 38.2620528 98.8219396 34.6994999 101.107521 30.845767 99.3907863 31.8626397 103.575227 29.0810811 106.807342 33.272041 107.107637 35.4069092 110.82194"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-22",
    fill: "#FFA81D",
    points: "344.175257 54.5589784 348.919467 56.1318415 347.208019 51.1720096 350.081081 46.8611736 345.115004 47.0587448 342.146605 42.8219396 340.788826 47.9039106 336.081081 49.5961105 340.207799 52.5393614 340.26689 57.8219396"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-24",
    fill: "#FFA81D",
    points: "341.60476 197.884251 343.579733 200.82194 344.694839 197.457098 348.081081 196.474217 345.246478 194.367024 345.364281 190.82194 342.496798 192.884132 339.18365 191.676008 340.246242 195.057993 338.081081 197.856393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.551245,284.82194 C352.75872,277.320083 354.287279,272.925072 355.51597,269.393235 C356.367429,266.945452 357.039855,265.011862 355.780546,262.243713 C352.008697,253.951788 355.669761,247.109217 355.827291,246.82194 L358.454357,248.136039 C358.324874,248.376592 355.312162,254.106493 358.499232,261.112265 C360.211499,264.876159 359.254163,267.627988 358.328847,270.288379 C357.134514,273.722296 356.006792,276.965514 360.081081,283.343075 L357.551245,284.82194 Z",
    id: "Fill-26",
    fill: "#FF6CCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.56315,128.82194 C330.280096,128.434188 323.672299,119.196903 326.869031,108.253153 C329.710143,98.525674 325.127696,91.3839525 325.081081,91.3129621 L327.678546,89.8219396 C327.896964,90.1548755 332.994098,98.0990578 329.80914,109.003943 C326.979321,118.692332 333.020049,127.132548 333.081081,127.216793 L330.56315,128.82194 Z",
    id: "Fill-28",
    fill: "#00AFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.569397,91.8219396 L289.081081,90.5738405 C289.129127,90.472837 293.904405,80.2645379 292.404733,69.6907448 C290.735154,57.9210342 298.862911,50.1471217 299.209493,49.8219396 L301.078897,51.9186027 L300.144414,50.8702711 L301.081081,51.9165871 C301.006829,51.9866849 293.69235,59.0336407 295.145942,69.2818037 C296.771843,80.7444726 291.782763,91.3749262 291.569397,91.8219396",
    id: "Fill-30",
    fill: "#FF6CCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.050888,317.82194 L221.191467,317.657042 C221.466728,312.88451 219.456575,309.020946 217.512585,305.284555 C215.316591,301.063412 213.242309,297.076288 214.934974,292.480173 C217.59365,285.261289 213.126469,271.874571 213.081081,271.740169 L215.794403,270.82194 C215.99289,271.409697 220.62717,285.312339 217.622554,293.47046 C216.367958,296.877508 218.075753,300.160318 220.053615,303.961763 C222.077542,307.852208 224.371536,312.261741 224.050888,317.82194",
    id: "Fill-32",
    fill: "#00AFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4758556,305.82194 C71.1294629,289.356818 73.2765624,279.756343 75.0019606,272.042257 C76.1252689,267.019268 77.0126847,263.051752 75.3213262,258.608234 C70.5809259,246.151067 75.2805653,239.115403 75.4830687,238.82194 L77.716243,240.494613 L76.5996559,239.658276 L77.7216633,240.486706 C77.5566686,240.732953 73.7273167,246.645595 77.8779855,257.551857 C79.8861079,262.828774 78.8640512,267.399934 77.680252,272.69244 C76.0342075,280.052744 73.9857579,289.212233 79.0810811,304.903596 L76.4758556,305.82194 Z",
    id: "Fill-34",
    fill: "#FF6CCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5890309,175.82194 C43.4843521,175.749828 40.9994724,174.019835 39.0202883,170.691938 C37.1824744,167.602125 35.4370369,162.499595 37.559318,155.738267 C41.0419914,144.64154 36.2852586,137.886852 36.0810811,137.604586 L38.2419962,135.82194 C38.4841603,136.150448 44.1238639,144.016115 40.1568623,156.655116 C36.7689393,167.449431 44.7400657,173.149916 45.0810811,173.387083 L43.5890309,175.82194 Z",
    id: "Fill-36",
    fill: "#00AFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.04467156,142.82194 C2.80062737,142.406326 -2.8748855,132.562219 2.1510165,125.551552 C6.25399573,119.828567 5.14666446,113.417308 5.13500139,113.35335 L7.87714268,112.82194 C7.93523796,113.131405 9.24458236,120.479814 4.40440922,127.231509 C0.473515252,132.714595 5.39026854,141.27506 5.44022168,141.36101 L3.04467156,142.82194 Z",
    id: "Fill-38",
    fill: "#FF6CCB"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-40",
    fill: "#FF6CCB",
    points: "4.85584546 107.82194 4.08108108 102.225467 7.30657316 101.82194 8.08108108 107.418412"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8969182,126.82194 C61.3740613,115.417393 63.2656315,110.845714 64.9345988,106.812066 C65.9783691,104.289588 66.8028656,102.297189 65.8423217,98.6588859 C63.0754314,88.1781729 64.8655763,83.0357436 64.9432543,82.8219396 L67.5820869,83.8255233 L66.2626706,83.323845 L67.5863037,83.8139356 C67.5707681,83.8591503 66.0609297,88.4408269 68.5599419,97.9068229 C69.773938,102.50554 68.6316276,105.266361 67.5268245,107.936298 C66.000119,111.625724 64.4214801,115.440796 68.5051234,125.737697 L65.8969182,126.82194 Z",
    id: "Fill-42",
    fill: "#FF6CCB"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-44",
    fill: "#00AFFF",
    points: "98.0810811 93.8219396 101.081081 93.8219396 101.081081 88.8219396 98.0810811 88.8219396"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-46",
    fill: "#FF6CCB",
    points: "82.5092021 152.82194 81.0810811 147.530608 83.65296 146.82194 85.0810811 152.113271"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-47",
    fill: "#00AFFF",
    points: "228.081081 83.8219396 231.081081 83.8219396 231.081081 79.8219396 228.081081 79.8219396"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-48",
    fill: "#FF6CCB",
    points: "219.884804 56.8219396 217.081081 55.7768289 218.277358 52.8219396 221.081081 53.8670502"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-49",
    fill: "#00AFFF",
    points: "187.451166 51.8219396 185.081081 44.6583314 187.710997 43.8219396 190.081081 50.9855478"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-50",
    fill: "#FF6CCB",
    points: "282.512667 138.82194 281.081081 136.035228 283.649495 134.82194 285.081081 137.608867"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-51",
    fill: "#00AFFF",
    points: "320.081081 185.82194 323.081081 185.82194 323.081081 180.82194 320.081081 180.82194"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-52",
    fill: "#FF6CCB",
    points: "208.081081 242.82194 211.081081 242.82194 211.081081 235.82194 208.081081 235.82194"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-56",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(256.632750, 320.688394)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-13",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2133545,0.0502384738 C13.9249603,2.85914149 7.37106518,4.15564388 2.68950715,4.33577107 L2.68950715,4.33577107 C-1.99189189,4.51589825 0.888871224,8.62082671 0.888871224,8.62082671 L0.888871224,8.62082671 L13.3489666,8.62082671 L15.7014308,6.10015898 L16.445469,8.62082671 L21.7755167,8.62082671 C22.927663,4.22766296 20.4069952,0.0502384738 20.4069952,0.0502384738 L20.4069952,0.0502384738 C20.4069952,0.0502384738 15.7976153,0.33863275 14.2133545,0.0502384738",
    id: "Fill-54",
    fill: "url(#linearGradient-14)",
    mask: "url(#mask-13)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-59",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(333.898251, 294.933227)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-16",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.05564388,0.237519873 C2.05564388,0.237519873 1.09507154,3.21430843 0.0386327504,6.09507154 L0.0386327504,6.09507154 C1.38346582,7.34387917 1.7672496,11.7612083 1.19125596,16.4667727 L1.19125596,16.4667727 C0.615262321,21.1718601 4.36025437,21.5561208 4.74419714,19.2515103 L4.74419714,19.2515103 C5.12861685,16.9467409 6.47281399,10.0324324 6.47281399,10.0324324 L6.47281399,10.0324324 L5.32019078,7.63211447 L7.4327504,7.05564388 L7.4327504,1.67790143 C5.67694754,0.375198728 4.12209857,0.108108108 3.14165342,0.108108108 L3.14165342,0.108108108 C2.45977742,0.108108108 2.05564388,0.237519873 2.05564388,0.237519873",
    id: "Fill-57",
    fill: "url(#linearGradient-17)",
    mask: "url(#mask-16)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-62",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(264.104928, 251.848967)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-19",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-18"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.454531002,0.108744038 C0.454531002,0.108744038 -0.317011129,10.4802862 0.454531002,29.709062 L0.454531002,29.709062 C1.22607313,48.9394277 5.44403816,69.681558 5.44403816,69.681558 L5.44403816,69.681558 C9.40508744,71.3389507 14.2314785,69.681558 14.2314785,69.681558 L14.2314785,69.681558 L15.6718601,52.1085851 C16.2763116,44.7281399 17.5421304,37.7771065 18.8073132,32.1995231 L18.8073132,32.1995231 C19.9704293,27.0688394 21.1335453,23.099682 21.7804452,21.0205087 L21.7804452,21.0205087 C22.1027027,19.9772655 22.2977742,19.4111288 22.2977742,19.4111288 L22.2977742,19.4111288 L12.1391097,0.108744038 L0.454531002,0.108744038 Z",
    id: "Fill-60",
    fill: "url(#linearGradient-20)",
    mask: "url(#mask-19)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M285.885215,272.869746 C285.238315,274.948442 284.075358,278.917917 282.912401,284.048442 C275.772019,273.168951 272.852782,253.775628 272.852782,253.775628 L284.549285,270.827933 C284.549285,270.827933 285.308744,271.36911 285.885215,272.869746",
    id: "Fill-63",
    fill: "#112E59"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-67",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(272.213037, 243.104928)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-22",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.121144674,8.85278219 C0.121144674,8.85278219 4.68298887,29.1627981 27.00938,43.8556439 L27.00938,43.8556439 C49.336248,58.5478537 61.5799682,59.9882353 61.5799682,59.9882353 L61.5799682,59.9882353 C61.5799682,59.9882353 65.7572337,56.5314785 64.6050874,50.481558 L64.6050874,50.481558 C64.6050874,50.481558 41.6626391,40.9747218 32.463434,17.9279809 L32.463434,17.9279809 C21.5354531,4.24324324 18.3794913,0.154372019 18.3794913,0.154372019 L18.3794913,0.154372019 L0.121144674,8.85278219 Z",
    id: "Fill-65",
    fill: "url(#linearGradient-23)",
    mask: "url(#mask-22)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-70",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(283.182830, 146.125596)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-25",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5327504,0.968203498 C6.34054054,2.74467409 7.58871224,6.68203498 7.10890302,7.49809221 L7.10890302,7.49809221 C6.62893482,8.31462639 5.57233704,5.91383148 4.61192369,3.94515103 L4.61192369,3.94515103 C3.65198728,1.97647059 2.25930048,2.64864865 3.50763116,5.28950715 L3.50763116,5.28950715 C4.75627981,7.93020668 5.7645469,11.7713831 5.47631161,12.7317965 L5.47631161,12.7317965 C5.32750397,13.2278219 3.97488076,13.1217806 2.66852146,13.0158983 L2.66852146,13.0158983 C1.44499205,12.9170111 0.26263911,12.8176471 0.146899841,13.2119237 L0.146899841,13.2119237 C-0.093163752,14.0278219 2.64324324,14.6523052 4.08410175,14.8922099 L4.08410175,14.8922099 C5.52464229,15.1327504 7.45151033,18.3496025 7.28012719,18.9255962 L7.28012719,18.9255962 L12.9666137,17.8213037 C12.9666137,17.8213037 11.8144674,15.6127186 12.9666137,12.6836248 L12.9666137,12.6836248 C14.1192369,9.75500795 14.8874404,4.71335453 14.1192369,4.18505564 L14.1192369,4.18505564 C13.3510334,3.65675676 13.0944356,6.44213037 12.45469,7.59411765 L12.45469,7.59411765 C11.8144674,8.74689984 11.382194,8.07472178 11.6222576,5.6254372 L11.6222576,5.6254372 C11.8621622,3.17678855 12.4481717,1.30429253 11.5553259,1.25643879 L11.5553259,1.25643879 C10.6618442,1.20826709 9.96613672,5.55357711 9.77392687,6.65786963 L9.77392687,6.65786963 C9.58171701,7.76216216 8.78314785,6.39761526 8.40540541,3.2009539 L8.40540541,3.2009539 C8.15119237,1.05055644 7.53068362,0.00874403816 7.06804452,0.00874403816 L7.06804452,0.00874403816 C6.81033386,0.00874403816 6.60158983,0.332432432 6.5327504,0.968203498",
    id: "Fill-68",
    fill: "url(#linearGradient-26)",
    mask: "url(#mask-25)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-73",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(256.155803, 147.874404)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-28",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-27"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.78426073,3.02877583 C5.42686804,6.05071542 4.67233704,7.34069952 4.49046105,6.29666137 L4.49046105,6.29666137 C4.30922099,5.25278219 3.6508744,1.14531002 2.80683625,1.19077901 L2.80683625,1.19077901 C1.96279809,1.236407 2.5163752,3.0063593 2.74308426,5.32098569 L2.74308426,5.32098569 C2.97058824,7.6354531 2.56200318,8.2709062 1.95675676,7.18139905 L1.95675676,7.18139905 C1.35166932,6.09252782 1.10953895,3.45993641 0.383465819,3.95898251 L0.383465819,3.95898251 C-0.343084261,4.45866455 0.383465819,9.22368839 1.47249603,11.9923688 L1.47249603,11.9923688 C2.56200318,14.7605723 1.47249603,16.8484897 1.47249603,16.8484897 L1.47249603,16.8484897 L6.84737679,17.8923688 C6.68600954,17.3476948 8.50699523,14.3069952 9.86883943,14.0798092 L9.86883943,14.0798092 C11.2302067,13.8529412 13.8171701,13.2631161 13.5903021,12.4915739 L13.5903021,12.4915739 C13.4799682,12.1187599 12.3624801,12.2125596 11.2065183,12.3060413 L11.2065183,12.3060413 C9.97154213,12.4065183 8.69316375,12.5065183 8.55246423,12.0375199 L8.55246423,12.0375199 C8.28012719,11.1297297 9.23338633,7.49936407 10.4135135,5.00302067 L10.4135135,5.00302067 C11.5930048,2.50715421 10.2774245,1.87170111 9.36963434,3.73227345 L9.36963434,3.73227345 C8.46200318,5.59332273 7.463593,7.86232114 7.00937997,7.09077901 L7.00937997,7.09077901 C6.55580286,6.31923688 7.7354531,2.59777424 7.55421304,0.918441971 L7.55421304,0.918441971 C7.48903021,0.317488076 7.29189189,0.0116056615 7.0481717,0.0116056615 L7.0481717,0.0116056615 C6.61096979,0.0116056615 6.02448331,0.996502385 5.78426073,3.02877583",
    id: "Fill-71",
    fill: "url(#linearGradient-29)",
    mask: "url(#mask-28)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-76",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(258.699523, 204.313196)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-31",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-30"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.85993641,4.43163752 L0.0890302067,40.4426073 L5.85993641,49.8054054 C5.85993641,49.8054054 22.754849,51.427027 32.4313196,40.4607313 L32.4313196,40.4607313 C33.1764706,30.0709062 27.7031797,18.8356121 27.7031797,18.8356121 L27.7031797,18.8356121 L19.1804452,0.0241653418 L5.85993641,4.43163752 Z",
    id: "Fill-74",
    fill: "url(#radialGradient-32)",
    mask: "url(#mask-31)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-79",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(273.007949, 162.977742)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-34",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-33"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.990461,1.59682035 C16.4659777,1.88298887 16.1343402,2.42670906 16.1262321,3.02352941 L16.1262321,3.02352941 C16.0597774,7.67249603 15.2354531,28.9138315 5.75993641,34.6753577 L5.75993641,34.6753577 C1.40810811,41.0801272 0.0950715421,42.3826709 0.0950715421,42.3826709 L0.0950715421,42.3826709 L0.649761526,43.7017488 L1.72718601,46.2710652 C1.72718601,46.2710652 7.28616852,66.2136725 10.6572337,76.3761526 L10.6572337,76.3761526 C12.9696343,83.34531 17.8718601,89.3643879 22.4379968,93.7976153 L22.4379968,93.7976153 C27.6421304,98.8513514 32.4081081,101.847536 32.4081081,101.847536 L32.4081081,101.847536 C32.4081081,101.847536 39.3217806,93.3017488 41.0510334,82.6422893 L41.0510334,82.6422893 C41.0510334,82.6422893 28.5664547,82.0662957 23.8613672,69.6771065 L23.8613672,69.6771065 C19.1558029,57.2901431 17.572655,53.9041335 21.3891892,42.7774245 L21.3891892,42.7774245 C25.0282989,32.1680445 27.6861685,10.1969793 25.6774245,1.30810811 L25.6774245,1.30810811 C25.5103339,0.56836248 24.8618442,0.0384737679 24.1034976,0.0225755167 L24.1034976,0.0225755167 C23.9952305,0.020190779 23.8812401,0.0189189189 23.7618442,0.0189189189 L23.7618442,0.0189189189 C22.10938,0.0189189189 19.4281399,0.265341812 16.990461,1.59682035",
    id: "Fill-77",
    fill: "url(#linearGradient-35)",
    mask: "url(#mask-34)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M295.445755,256.775405 C290.879777,252.342178 285.977711,246.322782 283.66531,239.353625 C280.294086,229.191622 274.734944,209.249014 274.734944,209.249014 L273.657838,206.67938 L273.652909,206.657599 L274.686296,205.864436 C274.686296,205.864436 276.175326,204.951717 277.855771,208.408633 C279.536375,211.865548 281.937647,216.811176 286.162448,217.051558 L283.282162,226.269046 L289.572305,227.421987 C289.572305,227.421987 286.40283,231.431685 290.076598,241.802114 C292.89806,249.774452 294.743211,254.852989 295.445755,256.775405",
    id: "Fill-80",
    fill: "#FFC764"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-84",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(250.750397, 163.931638)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-37",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.12225755,0.303020668 C6.12225755,0.303020668 1.2254372,9.95421304 0.217329094,30.2647059 L0.217329094,30.2647059 C-0.791414944,50.5740859 5.40333863,58.5443561 6.36263911,61.5224165 L6.36263911,61.5224165 C7.32432432,64.4987281 3.67408585,89.4659777 2.90588235,95.9968203 L2.90588235,95.9968203 C3.86740859,98.7810811 18.9600954,100.893641 18.9600954,100.893641 L18.9600954,100.893641 C18.9600954,100.893641 17.6607313,97.5860095 16.5651828,91.1802862 L16.5651828,91.1802862 C15.9705882,87.7031797 15.4340223,83.3101749 15.1972973,78.0383148 L15.1972973,78.0383148 C14.5251192,63.0583466 19.4340223,48.654849 19.4340223,48.654849 L19.4340223,48.654849 L19.5799682,47.8146264 L20.3109698,43.6066773 C20.3109698,43.6066773 19.600318,41.7780604 17.6085851,34.1537361 L17.6085851,34.1537361 C7.57472178,22.7311606 14.0930048,2.03227345 14.0930048,2.03227345 L14.0930048,2.03227345 C12.0472178,0.455961844 9.71462639,0.121621622 8.10381558,0.121621622 L8.10381558,0.121621622 C6.91732909,0.121621622 6.12225755,0.303020668 6.12225755,0.303020668",
    id: "Fill-82",
    fill: "url(#linearGradient-38)",
    mask: "url(#mask-37)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M270.184149,212.586502 C270.184149,212.586502 265.275405,226.990159 265.947742,241.970127 C266.184626,247.241828 266.720715,251.634674 267.315628,255.112116 C267.24663,255.212576 258.788601,232.559316 258.788601,232.559316 L263.547901,229.678871 L260.091145,224.205421 C268.636614,218.059952 268.685103,209.608601 268.685103,209.608601 L270.330413,211.746121 L270.184149,212.586502 Z",
    id: "Fill-85",
    fill: "#FFC764"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-89",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(269.192369, 203.518283)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-40",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-39"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-88"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-87",
    fill: "url(#linearGradient-41)",
    mask: "url(#mask-40)",
    points: "0.0694753577 2.63338633 0.0694753577 5.41812401 1.60540541 8.53879173 3.95786963 7.19459459 5.82988871 4.0200318 6.05993641 1.68887122 6.21478537 0.135930048"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-90",
    fill: "#EF89B0",
    points: "275.252639 205.207313 269.261542 208.867409 269.261542 206.909698 273.652798 204.726709 275.304944 204.681399"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-94",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(246.775835, 213.216216)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-43",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-42"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3739269,0.642130366 C23.3739269,0.642130366 20.3969793,12.0933227 10.3856916,19.6556439 L10.3856916,19.6556439 C1.82225755,26.1244833 0.158982512,32.4033386 0.158982512,32.4033386 L0.158982512,32.4033386 C-0.20127186,36.2209857 3.68775835,45.4392687 3.68775835,45.4392687 L3.68775835,45.4392687 C5.56041335,42.3427663 14.9232114,38.0934817 14.9232114,38.0934817 L14.9232114,38.0934817 C14.5629571,32.9079491 18.9565978,27.5780604 22.9351351,18.0712242 L22.9351351,18.0712242 C26.9136725,8.56406995 25.0300477,0.353895072 25.0300477,0.353895072 L25.0300477,0.353895072 L23.6379968,0.0419713831 L23.3739269,0.642130366 Z",
    id: "Fill-92",
    fill: "url(#linearGradient-44)",
    mask: "url(#mask-43)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-97",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(269.033386, 210.036566)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-46",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0356120827,1.49284579 C0.0356120827,1.49284579 0.827980922,3.65373609 1.1163752,3.8217806 L1.1163752,3.8217806 C1.40413355,3.98982512 2.72480127,4.13370429 3.13290938,3.8217806 L3.13290938,3.8217806 C3.54085851,3.50937997 4.06915739,1.49284579 4.06915739,1.49284579 L4.06915739,1.49284579 L2.96470588,0.292368839 L2.02845787,0.100158983 C2.02845787,0.100158983 1.98775835,0.0949125596 1.91701113,0.0949125596 L1.91701113,0.0949125596 C1.58791733,0.0949125596 0.608585056,0.208744038 0.0356120827,1.49284579",
    id: "Fill-95",
    fill: "url(#linearGradient-47)",
    mask: "url(#mask-46)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-100",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(270.941176, 206.538951)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-49",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-48"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.4254372,2.06136725 C0.576947536,3.2618442 0.120667727,3.59777424 0.120667727,3.59777424 L0.120667727,3.59777424 C0.120667727,3.59777424 1.96915739,5.01462639 2.37774245,6.71923688 L2.37774245,6.71923688 C2.37774245,6.71923688 3.69777424,3.83847377 4.70604134,2.94992051 L4.70604134,2.94992051 C5.71414944,2.06136725 5.38426073,0.407949126 4.16899841,0.118600954 L4.16899841,0.118600954 C4.16899841,0.118600954 4.27376789,0.861526232 2.4254372,2.06136725",
    id: "Fill-98",
    fill: "url(#linearGradient-50)",
    mask: "url(#mask-49)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-103",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(268.238474, 207.969793)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-52",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-51"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.254531002,1.11096979 C0.0623211447,1.66279809 0.13481717,5.12034976 0.13481717,5.12034976 L0.13481717,5.12034976 C0.590620032,3.96772655 2.82337043,2.16693164 2.82337043,2.16693164 L2.82337043,2.16693164 C1.38298887,1.83100159 1.0227345,0.0786963434 1.0227345,0.0786963434 L1.0227345,0.0786963434 C1.0227345,0.0786963434 0.446740859,0.558664547 0.254531002,1.11096979",
    id: "Fill-101",
    fill: "url(#linearGradient-53)",
    mask: "url(#mask-52)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-106",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(264.740859, 194.138315)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-55",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-54"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-105"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.103020668,0.778060413 C0.103020668,0.778060413 2.07170111,2.79443561 1.30349762,6.7799682 L1.30349762,6.7799682 C0.535294118,10.7651828 -0.376947536,13.982035 3.46438792,13.3098569 L3.46438792,13.3098569 C7.30556439,12.6378378 12.1551669,9.63672496 12.1551669,9.63672496 L12.1551669,9.63672496 L13.2594595,9.15675676 L14.027027,6.15564388 L9.1782194,0.0580286169 L0.103020668,0.778060413 Z",
    id: "Fill-104",
    fill: "url(#linearGradient-56)",
    mask: "url(#mask-55)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-109",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(258.699523, 176.014308)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-58",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-57"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-108"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.190620032,12.2759936 C1.38823529,22.9755167 15.3151033,19.7300477 15.3151033,19.7300477 L15.3151033,19.7300477 C16.6834658,22.4313196 14.8828299,26.500318 14.8828299,26.500318 L14.8828299,26.500318 C17.3321145,26.1039746 17.7642289,24.3039746 17.7642289,24.3039746 L17.7642289,24.3039746 C19.7790143,25.2863275 18.1965024,27.7607313 18.1965024,27.7607313 L18.1965024,27.7607313 C20.1410175,29.4174881 23.727345,27.0759936 22.5753577,25.1314785 L22.5753577,25.1314785 C21.4225755,23.1863275 22.9497615,23.0793323 22.8779014,20.990938 L22.8779014,20.990938 C22.8054054,18.9020668 19.6368839,17.8217806 19.6368839,17.8217806 L19.6368839,17.8217806 C19.6368839,17.8217806 21.0772655,14.6527822 18.8443561,12.8521463 L18.8443561,12.8521463 C16.6116057,11.0515103 11.9302067,13.1403816 9.55341812,8.74674086 L9.55341812,8.74674086 C7.17678855,4.35357711 11.7143084,1.1845787 11.7143084,1.1845787 L11.7143084,1.1845787 C10.6950715,0.474085851 9.53386328,0.134817114 8.34848967,0.134817114 L8.34848967,0.134817114 C4.00524642,0.135135135 -0.657869634,4.69427663 0.190620032,12.2759936",
    id: "Fill-107",
    fill: "url(#linearGradient-59)",
    mask: "url(#mask-58)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-112",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(111.004769, 314.488076)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-61",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-60"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0243243243,0.0567567568 L0.0243243243,6.03481717 L6.36248013,11.0758347 C6.36248013,11.0758347 9.74737679,11.5081081 10.0351351,10.2841017 L10.0351351,10.2841017 C10.3235294,9.05945946 7.80286169,6.75468998 6.5063593,5.17042925 L6.5063593,5.17042925 C5.20985692,3.58569157 6.07424483,0.0567567568 6.07424483,0.0567567568 L6.07424483,0.0567567568 L0.0243243243,0.0567567568 Z",
    id: "Fill-110",
    fill: "url(#linearGradient-62)",
    mask: "url(#mask-61)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-115",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(108.779014, 317.190779)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-64",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-63"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-114"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.24197138,6.86263911 C2.53831479,9.24038156 1.52957075,13.2710652 1.52957075,13.2710652 L1.52957075,13.2710652 L3.83434022,13.2710652 C3.83434022,13.2710652 3.83434022,9.0217806 4.48282989,9.0217806 L4.48282989,9.0217806 C5.13084261,9.0217806 7.86772655,13.1265501 11.0368839,13.5593005 L11.0368839,13.5593005 C14.2058824,13.990938 19.463434,13.6306836 19.1031797,12.3346582 L19.1031797,12.3346582 C18.7429253,11.0381558 12.1796502,6.86263911 12.1796502,6.86263911 L12.1796502,6.86263911 C8.06502385,9.52861685 2.25007949,0.0910969793 2.25007949,0.0910969793 L2.25007949,0.0910969793 C-0.776788553,1.30572337 -0.0546899841,4.48426073 1.24197138,6.86263911",
    id: "Fill-113",
    fill: "url(#linearGradient-65)",
    mask: "url(#mask-64)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-118",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(75.869634, 308.605723)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-67",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-66"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-117"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.132432432,6.63497615 L4.50429253,13.9337043 L7.7672496,17.0324324 C7.7672496,17.0324324 8.48712242,15.7578696 8.39157393,14.4135135 L8.39157393,14.4135135 C8.29554849,13.0693164 6.18235294,9.51621622 6.18235294,8.17201908 L6.18235294,8.17201908 C6.18235294,6.82718601 9.35151033,3.65802862 9.35151033,3.65802862 L9.35151033,3.65802862 L4.50429253,0.10508744 L0.132432432,6.63497615 Z",
    id: "Fill-116",
    fill: "url(#linearGradient-68)",
    mask: "url(#mask-67)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-121",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(71.577107, 312.739269)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-70",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-69"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.50461049,2.81383148 C2.21701113,4.61446741 0.127980922,6.48871224 0.127980922,6.48871224 L0.127980922,6.48871224 L1.49650238,8.64737679 C1.49650238,8.64737679 3.44101749,5.5508744 4.42496025,6.77535771 L4.42496025,6.77535771 C5.02686804,7.52337043 5.55691574,9.45516693 5.87758347,10.8438792 L5.87758347,10.8438792 C6.09888712,11.8 6.69030207,12.6287758 7.52829889,13.1387917 L7.52829889,13.1387917 C8.32559618,13.6248013 9.509062,14.3914149 11.1476948,15.5616852 L11.1476948,15.5616852 C14.6763116,18.082194 16.5248013,16.7136725 16.2370429,14.8895072 L16.2370429,14.8895072 C15.9488076,13.0651828 12.5693164,9.70890302 12.5693164,9.70890302 L12.5693164,9.70890302 C7.65294118,10.6265501 6.01096979,0.13290938 6.01096979,0.13290938 L6.01096979,0.13290938 C5.82162162,0.0583465819 5.62034976,0.0232114467 5.41351351,0.0232114467 L5.41351351,0.0232114467 C4.1799682,0.0232114467 2.75166932,1.2718601 2.50461049,2.81383148",
    id: "Fill-119",
    fill: "url(#linearGradient-71)",
    mask: "url(#mask-70)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-124",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(78.731320, 241.515103)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-73",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-72"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7570747,5.25596184 C15.6160572,17.9120827 14.5100159,28.1079491 12.9472178,36.2720191 L12.9472178,36.2720191 C8.4217806,59.899841 0.0561208267,66.5246423 0.0561208267,66.5246423 L0.0561208267,66.5246423 C1.20874404,69.8855326 6.96979332,72.0934817 6.96979332,72.0934817 L6.96979332,72.0934817 C12.5491256,66.4120827 17.118442,60.7351351 20.8575517,55.2007949 L20.8575517,55.2007949 C22.6944356,52.4837838 24.3308426,49.800159 25.7877583,47.1680445 L25.7877583,47.1680445 C28.5624801,42.1604134 30.6882353,37.3373609 32.3114467,32.8135135 L32.3114467,32.8135135 C33.2241653,30.2742448 33.9786963,27.8306836 34.6009539,25.500159 L34.6009539,25.500159 C38.6387917,10.3801272 37.1230525,0.0721780604 37.1230525,0.0721780604 L37.1230525,0.0721780604 C37.1230525,0.0721780604 29.7052464,2.87980922 15.7570747,5.25596184",
    id: "Fill-122",
    fill: "url(#linearGradient-74)",
    mask: "url(#mask-73)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M104.519316,288.683386 C103.062242,291.315024 101.425517,293.998967 99.5886328,296.716137 C99.0762321,289.007711 91.7945151,277.961765 91.6802067,277.788633 L104.519316,288.683386 Z",
    id: "Fill-125",
    fill: "#3A55DB"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-129",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(80.321145, 242.786963)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-76",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-75"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-128"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.94069952,22.9987281 C9.96581876,37.9077901 26.0265501,45.181717 28.3313196,57.7136725 L28.3313196,57.7136725 C30.636089,70.245151 29.8717011,72.2620032 29.8717011,72.2620032 L29.8717011,72.2620032 C29.8717011,72.2620032 33.8050874,74.5667727 37.9823529,72.2620032 L37.9823529,72.2620032 C37.9823529,72.2620032 41.2146264,45.1011129 31.2588235,30.009062 L31.2588235,30.009062 C20.5526232,13.7802862 23.145787,2.68871224 23.145787,2.68871224 L23.145787,2.68871224 L3.91589825,0.0961844197 C3.91589825,0.0961844197 -4.08394277,8.09062003 2.94069952,22.9987281",
    id: "Fill-127",
    fill: "url(#linearGradient-77)",
    mask: "url(#mask-76)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-132",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(82.228935, 204.631161)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-79",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-78"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.08219396,0.127980922 C8.08219396,0.127980922 10.3627981,0.872496025 10.218283,2.24101749 L10.218283,2.24101749 C10.0744038,3.60953895 5.82527822,4.68966614 1.79189189,2.16915739 L1.79189189,2.16915739 C0.783624801,3.03290938 0.0635930048,9.15468998 0.0635930048,9.15468998 L0.0635930048,9.15468998 L6.64626391,41.8526232 L13.5796502,44.3019078 C13.5796502,44.3019078 25.2713831,47.1826709 33.6254372,37.963752 L33.6254372,37.963752 C32.4732909,29.1769475 29.0165342,19.9585056 29.0165342,19.9585056 L29.0165342,19.9585056 L21.045787,7.3782194 L12.7872814,0.656120827 C12.7872814,0.656120827 10.8281399,0.107790143 8.7508744,0.107790143 L8.7508744,0.107790143 C8.52861685,0.107790143 8.30492846,0.113990461 8.08219396,0.127980922",
    id: "Fill-130",
    fill: "url(#radialGradient-80)",
    mask: "url(#mask-79)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-135",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(27.379968, 186.507154)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-82",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-81"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.02209857,0.0957074722 C3.91780604,0.86391097 8.2899841,5.09395866 7.95389507,6.03131955 L7.95389507,6.03131955 C7.61796502,6.96868045 2.76836248,1.11096979 1.76009539,0.966613672 L1.76009539,0.966613672 C0.751987281,0.822734499 0.991891892,2.11923688 3.53672496,4.66391097 L3.53672496,4.66391097 C6.08139905,7.20874404 6.94562798,7.83195548 5.74531002,7.7836248 L5.74531002,7.7836248 C4.54483307,7.73593005 0.751987281,3.03131955 0.127503975,4.52019078 L0.127503975,4.52019078 C-0.496343402,6.00826709 4.73704293,8.02527822 4.8809221,9.46565978 L4.8809221,9.46565978 C4.95675676,10.2262321 3.88314785,9.61939587 2.83052464,9.01255962 L2.83052464,9.01255962 C1.88918919,8.46947536 0.965023847,7.92702703 0.895866455,8.36136725 L0.895866455,8.36136725 C0.703656598,9.5618442 2.3845787,11.2421304 6.41748808,12.154213 L6.41748808,12.154213 C10.4508744,13.0662957 13.1877583,14.2190779 14.8203498,15.6594595 L14.8203498,15.6594595 C15.8286169,13.690779 17.172973,12.154213 17.172973,12.154213 L17.172973,12.154213 C17.172973,12.154213 14.36407,10.4860095 14.7961844,7.10651828 L14.7961844,7.10651828 C15.2284579,3.72766296 14.7720191,1.35103339 13.6677266,2.74356121 L13.6677266,2.74356121 C12.563434,4.13577107 12.8995231,8.43593005 11.7473768,7.24610493 L11.7473768,7.24610493 C10.6526232,6.1163752 6.48839428,0.0440381558 5.20111288,0.0432421393 L5.20111288,0.0432421393 C5.13306836,0.0430842607 5.07313196,0.0600953895 5.02209857,0.0957074722",
    id: "Fill-133",
    fill: "url(#linearGradient-83)",
    mask: "url(#mask-82)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-138",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(41.529412, 196.682035)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-85",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-84"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.142130366,6.07488076 C0.142130366,6.07488076 2.59077901,10.7650238 12.5306836,18.1917329 L12.5306836,18.1917329 C22.4696343,25.6176471 37.0174881,25.7473768 40.763752,34.9645469 L40.763752,34.9645469 C44.5077901,44.1841017 36.1537361,50.2340223 36.1537361,50.2340223 L36.1537361,50.2340223 C40.9065183,59.4529412 52.9589825,58.4448331 52.9589825,58.4448331 L52.9589825,58.4448331 C55.5416534,48.782035 55.8222576,40.7168521 54.899682,34.1195548 L54.899682,34.1195548 C52.5602544,17.4119237 42.490779,10.118283 42.490779,10.118283 L42.490779,10.118283 L42.9058824,6.57233704 L42.9228935,6.43465819 C42.8559618,6.46311606 42.7883943,6.4899841 42.7214626,6.51526232 L42.7214626,6.51526232 C41.8624801,6.86518283 41.0119237,7.17583466 40.1667727,7.44992051 L40.1667727,7.44992051 C19.8195548,14.072655 3.45612083,0.0591414944 3.45612083,0.0591414944 L3.45612083,0.0591414944 C-0.0984101749,3.2281399 0.142130366,6.07488076 0.142130366,6.07488076",
    id: "Fill-136",
    fill: "url(#linearGradient-86)",
    mask: "url(#mask-85)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-141",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(89.701113, 203.041335)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-88",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-87"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-140"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.92686804,0.391573927 C1.32225755,0.525596184 0.69682035,0.70572337 0.0416534181,0.932432432 L0.0416534181,0.932432432 C0.0416534181,0.934022258 0.0432432432,0.935771065 0.0432432432,0.93736089 L0.0432432432,0.93736089 C0.0449920509,0.952782194 0.0548489666,0.994435612 0.0767885533,1.05500795 L0.0767885533,1.05500795 C0.122416534,1.18616852 0.221303657,1.39984102 0.424324324,1.5809221 L0.424324324,1.5809221 C0.478219396,1.62988871 0.53863275,1.67551669 0.609379968,1.71717011 L0.609379968,1.71717011 C0.611128776,1.71717011 0.614467409,1.71891892 0.616057234,1.71891892 L0.616057234,1.71891892 C0.680286169,1.73259141 1.19427663,1.85007949 2.06629571,2.24165342 L2.06629571,2.24165342 C2.38918919,2.38600954 2.76216216,2.57106518 3.17885533,2.80127186 L3.17885533,2.80127186 C6.57042925,4.67329094 12.8958665,9.63577107 19.526868,22.4127186 L19.526868,22.4127186 C19.6767886,22.7014308 19.8228935,22.9893482 19.9672496,23.273132 L19.9672496,23.273132 C23.0243243,29.3483307 24.6238474,34.5613672 25.3971383,38.8144674 L25.3971383,38.8144674 C25.4777424,39.2629571 25.5497615,39.700159 25.6139905,40.1252782 L25.6139905,40.1252782 C26.7717011,47.8774245 25.145151,52.0855326 25.145151,52.0855326 L25.145151,52.0855326 C25.145151,52.0855326 25.4607313,52.0014308 25.9534181,51.836725 L25.9534181,51.836725 C27.2806041,51.3880763 29.8957075,50.3480127 31.0499205,48.7713831 L31.0499205,48.7713831 C31.0499205,48.7713831 29.754531,30.6217806 21.8325914,17.3710652 L21.8325914,17.3710652 C21.8325914,17.3710652 24.5349762,17.2518283 28.1329094,16.5527822 L28.1329094,16.5527822 C31.8198728,15.836725 36.4480127,14.5111288 40.0761526,12.0794913 L40.0761526,12.0794913 C40.3721781,11.8828299 40.6610493,11.6775835 40.9416534,11.4643879 L40.9416534,11.4643879 L39.8631161,5.15039746 C39.8631161,5.15039746 40.1766296,3.87965024 39.6263911,4.3009539 L39.6263911,4.3009539 C37.4656598,5.95707472 31.209221,9.66550079 22.0243243,5.99062003 L22.0243243,5.99062003 C13.3672496,2.52750397 9.1645469,0.0750397456 4.71319555,0.0750397456 L4.71319555,0.0750397456 C3.80794913,0.0750397456 2.89220986,0.176470588 1.92686804,0.391573927",
    id: "Fill-139",
    fill: "url(#linearGradient-89)",
    mask: "url(#mask-88)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M117.834038,219.594149 C114.236105,220.293196 111.533879,220.412432 111.533879,220.412432 L109.081892,216.639777 L107.935787,214.876979 C107.981256,214.918951 108.446757,215.34248 109.238331,215.92213 C110.927202,217.164102 114.104944,219.123561 117.834038,219.594149",
    id: "Fill-142",
    fill: "#CC46AA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-146",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(89.701113, 203.359300)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-91",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-90"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-145"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0416534181,0.614467409 C0.0416534181,0.614467409 0.128934817,1.11208267 0.609379968,1.39920509 L0.609379968,1.39920509 C0.609379968,1.39920509 9.73290938,3.22464229 19.526868,22.0947536 L19.526868,22.0947536 C19.6767886,22.3834658 19.8228935,22.6713831 19.9672496,22.9551669 L19.9672496,22.9551669 C17.6702703,14.5961844 20.4917329,9.99491256 20.4917329,9.99491256 L20.4917329,9.99491256 C15.9508744,9.87249603 5.16025437,2.38934817 1.92686804,0.073608903 L1.92686804,0.073608903 C1.32225755,0.207631161 0.69682035,0.387758347 0.0416534181,0.614467409",
    id: "Fill-144",
    fill: "url(#linearGradient-92)",
    mask: "url(#mask-91)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-149",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(81.593005, 203.041335)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-94",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-93"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.10317965,1.09062003 C1.26788553,3.22464229 4.39189189,10.1316375 2.59523052,20.1596184 L2.59523052,20.1596184 C2.59523052,20.1596184 11.8300477,18.4149444 14.8344992,27.7602544 L14.8344992,27.7602544 L14.836089,27.7602544 C12.4966614,11.0526232 2.42718601,3.75898251 2.42718601,3.75898251 L2.42718601,3.75898251 L2.84228935,0.213036566 L2.65786963,0.155961844 C1.79888712,0.505882353 0.948330684,0.816534181 0.10317965,1.09062003",
    id: "Fill-147",
    fill: "url(#linearGradient-95)",
    mask: "url(#mask-94)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-152",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(83.182830, 200.656598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-97",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-96"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-151"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.079491256,0.453418124 L0.234340223,1.61494436 L0.83736089,6.14372019 C0.83736089,6.14372019 3.35850556,8.32861685 7.22337043,7.75214626 L7.22337043,7.75214626 C11.0887122,7.17551669 9.62511924,5.06343402 9.62511924,5.06343402 L9.62511924,5.06343402 C9.62511924,5.06343402 8.71255962,4.63131955 7.12766296,4.10190779 L7.12766296,4.10190779 C6.90429253,3.98600954 6.73449921,3.74721781 6.60826709,3.44356121 L6.60826709,3.44356121 C6.11128776,2.24864865 6.26391097,0.0217806041 6.26391097,0.0217806041 L6.26391097,0.0217806041 L0.079491256,0.453418124 Z",
    id: "Fill-150",
    fill: "url(#linearGradient-98)",
    mask: "url(#mask-97)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M89.7913196,204.099873 L83.4170747,202.271415 L83.2625437,201.110207 L89.4468045,200.67841 C89.4468045,200.67841 89.2938633,202.90496 89.7913196,204.099873",
    id: "Fill-153",
    fill: "#ED88AF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-157",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(78.731320, 187.461049)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-100",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0561208267,7.79570747 L1.40047695,13.8895072 C1.40047695,13.8895072 1.78473768,14.3694754 5.145469,14.5852146 L5.145469,14.5852146 C10.8011129,15.0157393 17.5330684,14.1772655 17.0531002,12.0647059 L17.0531002,12.0647059 C16.573132,9.95214626 13.0680445,3.61399046 13.0680445,3.61399046 L13.0680445,3.61399046 L11.963593,0.541017488 L8.56661367,0.0610492846 L0.0561208267,7.79570747 Z",
    id: "Fill-155",
    fill: "url(#linearGradient-101)",
    mask: "url(#mask-100)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-160",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(18.000000, 134.837838)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-103",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-102"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-159"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.96216216,1.0200318 C6.14896661,1.28696343 5.42146264,1.60651828 4.77233704,1.96772655 L4.77233704,1.96772655 C-3.663593,6.66788553 1.16438792,18.7538951 4.44117647,23.636407 L4.44117647,23.636407 C7.97042925,28.8926868 9.19554849,33.3578696 10.1313196,38.1842607 L10.1313196,38.1842607 C11.0677266,43.008903 15.4624801,46.827027 22.7588235,47.2104928 L22.7588235,47.2104928 C30.0575517,47.5953895 32.0739269,50.9561208 34.3798092,56.2383148 L34.3798092,56.2383148 C36.6839428,61.518283 44.4861685,60.8713831 48.5920509,59.2866455 L48.5920509,59.2866455 C52.6974563,57.7017488 56.6413355,58.3502385 56.6413355,58.3502385 L56.6413355,58.3502385 L55.7220986,53.309221 C55.7220986,53.309221 54.0653418,49.2756757 49.9600954,49.2033386 L49.9600954,49.2033386 C45.8540541,49.1313196 43.6949126,47.9062003 42.6141494,44.5213037 L42.6141494,44.5213037 C41.5333863,41.1368839 38.7958665,39.0480127 32.6742448,37.1759936 L32.6742448,37.1759936 C26.5534181,35.3023847 25.6879173,33.7190779 25.545151,28.0289348 L25.545151,28.0289348 C25.4007949,22.3387917 24.1756757,20.1779014 21.1510334,18.4502385 L21.1510334,18.4502385 C18.1257552,16.7209857 20.791256,11.9682035 20.7187599,8.79920509 L20.7187599,8.79920509 C20.6591415,6.190938 19.0899841,0.0721780604 12.1944356,0.0728139905 L12.1944356,0.0728139905 C10.7101749,0.0728139905 8.97806041,0.356756757 6.96216216,1.0200318",
    id: "Fill-158",
    fill: "url(#linearGradient-104)",
    mask: "url(#mask-103)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-163",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(18.000000, 136.745628)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-106",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-105"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-162"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.44117647,21.7286169 C7.97042925,26.9848967 9.19554849,31.4500795 10.1313196,36.2764706 L10.1313196,36.2764706 C11.0677266,41.1011129 15.4624801,44.9192369 22.7588235,45.3027027 L22.7588235,45.3027027 C30.0575517,45.6875994 32.0739269,49.0483307 34.3798092,54.3305246 L34.3798092,54.3305246 C36.6839428,59.6104928 44.4861685,58.963593 48.5920509,57.3788553 L48.5920509,57.3788553 C52.6974563,55.7939587 56.6413355,56.4424483 56.6413355,56.4424483 L56.6413355,56.4424483 C56.6413355,56.4424483 51.5678855,52.8883943 45.8073132,54.0410175 L45.8073132,54.0410175 C40.0446741,55.1942766 36.6839428,52.5050874 35.3391097,48.663434 L35.3391097,48.663434 C33.9949126,44.8220986 28.5214626,39.9248013 23.6243243,39.7332273 L23.6243243,39.7332273 C18.7259141,39.5416534 13.5414944,35.508744 13.1565978,28.7866455 L13.1565978,28.7866455 C12.7732909,22.0647059 11.2356121,18.99062 7.87488076,16.4936407 L7.87488076,16.4936407 C5.0936407,14.4282989 1.91573927,5.51796502 4.77233704,0.059936407 L4.77233704,0.059936407 C-3.663593,4.76009539 1.16438792,16.8461049 4.44117647,21.7286169",
    id: "Fill-161",
    fill: "url(#linearGradient-107)",
    mask: "url(#mask-106)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-166",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(72.213037, 186.825119)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-109",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-108"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-165"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.07647059,0.385055644 C-0.435930048,1.39332273 -0.940063593,7.80333863 3.95771065,6.65071542 L3.95771065,6.65071542 C3.52559618,3.62607313 3.95771065,1.46518283 3.95771065,1.46518283 L3.95771065,1.46518283 C3.95771065,1.46518283 3.06963434,0.110015898 1.93354531,0.110015898 L1.93354531,0.110015898 C1.65930048,0.110015898 1.37058824,0.189030207 1.07647059,0.385055644",
    id: "Fill-164",
    fill: "url(#linearGradient-110)",
    mask: "url(#mask-109)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-169",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(74.597774, 182.532591)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-112",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-168"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.35103339,3.02082671 C8.27074722,3.02082671 1.42845787,2.58871224 0.276470588,6.1899841 L0.276470588,6.1899841 C-0.876152623,9.79109698 2.65310016,12.1678855 2.22098569,14.2562798 L2.22098569,14.2562798 C1.78871224,16.345151 3.1572337,22.2507154 9.27901431,19.5136725 L9.27901431,19.5136725 C9.27901431,19.5136725 5.31812401,18.7219396 6.68664547,16.0569157 L6.68664547,16.0569157 C7.48934817,14.4923688 8.36740859,15.1869634 9.33402226,15.881717 L9.33402226,15.881717 C10.0143084,16.3704293 10.7386328,16.8586645 11.5119237,16.5610493 L11.5119237,16.5610493 C12.9523052,14.400159 14.3448331,10.1992051 14.0807631,6.14165342 L14.0807631,6.14165342 C14.0807631,6.14165342 16.4332273,7.15039746 17.2015898,8.54244833 L17.2015898,8.54244833 C17.2015898,8.54244833 17.9939587,1.94069952 14.6809221,0.355802862 L14.6809221,0.355802862 C14.1604134,0.106995231 13.6984102,0.00206677265 13.2853736,0.00206677265 L13.2853736,0.00206677265 C11.0694754,0.00206677265 10.2613672,3.02082671 9.35103339,3.02082671",
    id: "Fill-167",
    fill: "url(#linearGradient-113)",
    mask: "url(#mask-112)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-172",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(128.174881, 206.062003)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-115",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-114"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-171"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.85659777,0.108903021 C3.88521463,0.533863275 1.57281399,1.53720191 0.808267091,1.78982512 L0.808267091,1.78982512 C-0.16899841,2.1127186 -0.110333863,3.95071542 1.00381558,3.86947536 L1.00381558,3.86947536 C1.00381558,3.86947536 -0.37281399,5.28680445 1.05612083,5.78759936 L1.05612083,5.78759936 C1.05612083,5.78759936 0.43608903,7.47281399 1.52337043,8.11144674 L1.52337043,8.11144674 C1.52337043,8.11144674 0.26963434,9.03354531 1.74960254,9.67440382 L1.74960254,9.67440382 C3.22957075,10.3152623 6.52209857,9.08950715 6.71224165,7.80190779 L6.71224165,7.80190779 C6.9027027,6.51462639 6.07567568,6.59427663 6.07567568,6.59427663 L6.07567568,6.59427663 C6.07567568,6.59427663 6.73577107,5.23243243 5.81764706,4.42400636 L5.81764706,4.42400636 C5.81764706,4.42400636 6.7254372,3.30222576 5.76979332,2.13577107 L5.76979332,2.13577107 C5.76979332,2.13577107 6.67154213,1.12368839 5.80222576,0.276947536 L5.80222576,0.276947536 C5.63990461,0.118600954 5.42448331,0.0359300477 5.20556439,0.0359300477 L5.20556439,0.0359300477 C5.08759936,0.0359300477 4.96868045,0.0597774245 4.85659777,0.108903021",
    id: "Fill-170",
    fill: "url(#linearGradient-116)",
    mask: "url(#mask-115)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-175",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(149.001590, 226.570747)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-118",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-117"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-174"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.82034976,5.56565978 C-0.404610493,5.46693164 -0.212400636,8.11319555 0.411287758,9.07313196 L0.411287758,9.07313196 C1.03577107,10.0335453 10.7346582,9.07313196 10.7346582,9.07313196 L10.7346582,9.07313196 L12.463434,7.00890302 L13.6154213,8.49697933 L17.9372019,8.20937997 C19.1853736,4.94419714 17.9372019,1.63116057 17.9372019,1.63116057 L17.9372019,1.63116057 C17.9372019,1.63116057 14.7680445,1.00683625 12.6071542,0.046899841 L12.6071542,0.046899841 C12.2712242,3.59984102 8.04610493,5.6645469 3.82034976,5.56565978",
    id: "Fill-173",
    fill: "url(#linearGradient-119)",
    mask: "url(#mask-118)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M191.375866,230.345024 C190.024674,229.145024 186.951065,226.360604 183.474118,222.824674 C184.67062,210.876184 187.967758,198.872369 187.967758,198.872369 L190.658219,219.102258 L191.375866,230.345024 Z",
    id: "Fill-176",
    fill: "#112F5B"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-180",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(147.411765, 110.513514)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-121",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-120"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-179"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.2581876,7.4709062 C4.2581876,7.4709062 2.52941176,7.43465819 2.20540541,8.83942766 L2.20540541,8.83942766 C2.20540541,8.83942766 0.621144674,8.80317965 0.765023847,10.6756757 L0.765023847,10.6756757 C0.765023847,10.6756757 -0.279332273,11.1798092 0.0807631161,12.6564388 L0.0807631161,12.6564388 C0.441017488,14.1325914 1.66518283,16.2933227 3.24992051,16.9775835 L3.24992051,16.9775835 C4.83418124,17.6618442 5.95055644,18.9220986 6.09443561,19.4624801 L6.09443561,19.4624801 C7.1027027,19.0666137 10.5238474,17.6262321 10.5238474,17.6262321 L10.5238474,17.6262321 C10.5238474,17.6262321 8.91764706,13.5926868 8.92861685,10.6400636 L8.92861685,10.6400636 C8.93958665,7.68680445 1.80953895,0.0526232114 1.08903021,0.0526232114 L1.08903021,0.0526232114 C0.369157393,0.0526232114 4.2581876,7.4709062 4.2581876,7.4709062",
    id: "Fill-178",
    fill: "url(#linearGradient-122)",
    mask: "url(#mask-121)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-183",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(152.976153, 127.047695)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-124",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-123"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-182"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.58394277,0.219872814 L0.609220986,2.30937997 C0.150079491,2.55039746 -0.0224165342,3.12098569 0.225755167,3.57694754 L0.225755167,3.57694754 L1.07042925,5.12480127 L6.61621622,2.02829889 L5.83100159,0.59554849 C5.66200318,0.287917329 5.34403816,0.113195548 5.0154213,0.113195548 L5.0154213,0.113195548 C4.86947536,0.113195548 4.7217806,0.147535771 4.58394277,0.219872814",
    id: "Fill-181",
    fill: "url(#linearGradient-125)",
    mask: "url(#mask-124)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-186",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(187.157393, 192.707472)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-127",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-126"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.38775835,3.27631161 C1.38775835,3.27631161 -3.53783784,21.3166932 5.41240064,46.7775835 L5.41240064,46.7775835 L15.7561208,46.5589825 L25.8756757,46.0319555 C25.6971383,39.1122417 25.3540541,22.0844197 25.9618442,11.6793323 L25.9618442,11.6793323 C20.6896661,1.40381558 16.8006359,0.107790143 16.8006359,0.107790143 L16.8006359,0.107790143 L1.38775835,3.27631161 Z",
    id: "Fill-184",
    fill: "url(#linearGradient-128)",
    mask: "url(#mask-127)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-189",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(152.976153, 128.001590)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-130",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-129"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-188"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.13418124,4.84308426 C0.13418124,4.84308426 15.2586645,39.8936407 28.2227345,45.2236884 L28.2227345,45.2236884 L37.681717,28.3220986 L35.0885533,25.9926868 C35.0885533,25.9926868 15.4030207,17.9993641 7.48060413,0.138155803 L7.48060413,0.138155803 C7.48060413,0.138155803 1.28616852,1.67408585 0.13418124,4.84308426",
    id: "Fill-187",
    fill: "url(#linearGradient-131)",
    mask: "url(#mask-130)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-192",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(180.957075, 157.254372)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-133",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-132"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.58807631,0.125914149 L0.0979332273,27.3500795 L0.817806041,38.4416534 C0.817806041,38.4416534 11.7496025,46.36407 22.2007949,41.75469 L22.2007949,41.75469 L21.2468998,0.125914149 L7.58807631,0.125914149 Z",
    id: "Fill-190",
    fill: "url(#radialGradient-134)",
    mask: "url(#mask-133)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-195",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(176.346582, 154.710652)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-136",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-135"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8713831,0.125596184 C12.8713831,0.125596184 6.53259141,4.35055644 3.84356121,15.5866455 L3.84356121,15.5866455 C1.15484897,26.8203498 4.90063593,41.609221 0.09936407,45.0661367 L0.09936407,45.0661367 L5.95596184,51.309221 C5.95596184,51.309221 7.84833068,47.7146264 8.56613672,39.8761526 L8.56613672,39.8761526 C8.74244833,37.9591415 8.84833068,35.7861685 8.83847377,33.3507154 L8.83847377,33.3507154 C8.74069952,9.91939587 14.6357711,4.35055644 14.6357711,4.35055644 L14.6357711,4.35055644 L15.1519873,2.0782194 C15.1519873,2.07662957 15.1535771,2.07662957 15.1535771,2.07662957 L15.1535771,2.07662957 L15.6071542,0.0766295707 L12.8713831,0.125596184 Z",
    id: "Fill-193",
    fill: "url(#linearGradient-137)",
    mask: "url(#mask-136)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M191.498521,156.788919 L190.982623,159.061097 C190.982623,159.061097 185.087393,164.630254 185.184849,188.061574 C185.194865,190.496709 185.088983,192.669523 184.912512,194.587011 C184.45035,188.628029 179.780238,175.684626 179.780238,175.684626 L184.199952,172.216105 L182.783418,166.551081 C186.848442,164.944404 191.359094,157.034229 191.498521,156.788919",
    id: "Fill-196",
    fill: "#7185EA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-200",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(197.809221, 153.915739)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-139",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-138"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-199"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.386009539,2.16756757 C0.386009539,2.16756757 1.39427663,2.45643879 1.10715421,12.3952305 L1.10715421,12.3952305 C0.922098569,18.7828299 0.379491256,30.6992051 0.192686804,40.6710652 L0.192686804,40.6710652 C0.0883942766,46.2168521 0.0939586645,51.1613672 0.330683625,54.2162162 L0.330683625,54.2162162 C2.05007949,60.0744038 9.46057234,59.208903 16.3995231,55.5604134 L16.3995231,55.5604134 C23.3384738,51.9109698 30.4926868,54.0244833 30.4926868,54.0244833 L30.4926868,54.0244833 C30.4926868,54.0244833 27.9952305,49.2216216 22.9046105,38.9473768 L22.9046105,38.9473768 C17.8163752,28.672337 20.7926868,11.290938 17.2397456,7.25739269 L17.2397456,7.25739269 C14.5193959,4.16915739 6.04610493,1.59920509 2.22798092,0.566295707 L2.22798092,0.566295707 C1.06152623,0.251669316 0.330683625,0.0785373609 0.330683625,0.0785373609 L0.330683625,0.0785373609 L0.386009539,2.16756757 Z",
    id: "Fill-198",
    fill: "url(#linearGradient-140)",
    mask: "url(#mask-139)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M206.406391,182.156328 C206.406391,182.156328 200.526264,186.57938 198.002099,194.587011 C198.188585,184.614833 198.73151,172.698299 198.916248,166.3107 C199.203688,156.372226 198.195421,156.083196 198.195421,156.083196 L198.139936,153.994165 C198.139936,153.994165 198.870938,154.167297 200.037075,154.481606 C200.475866,155.543609 200.91275,157.170477 201.220223,159.660938 C202.085723,166.670318 204.245183,172.07318 205.614817,172.864754 L202.373164,177.187011 L206.406391,182.156328 Z",
    id: "Fill-201",
    fill: "#7185EA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-205",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(205.122417, 191.753577)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-142",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-141"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-204"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.13481717,1.85023847 C1.43354531,5.44769475 8.34228935,7.75961844 8.34228935,7.75961844 L8.34228935,7.75961844 C9.35039746,7.39936407 9.96057234,5.68982512 9.96057234,5.68982512 L9.96057234,5.68982512 C4.06883943,5.38282989 1.65930048,0.0117647059 1.65930048,0.0117647059 L1.65930048,0.0117647059 C-0.0694753577,0.621780604 0.13481717,1.85023847 0.13481717,1.85023847",
    id: "Fill-203",
    fill: "url(#linearGradient-143)",
    mask: "url(#mask-142)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-208",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(191.926868, 152.007949)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-145",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-144"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-207"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-206",
    fill: "url(#linearGradient-146)",
    mask: "url(#mask-145)",
    points: "0.0275039746 2.77933227 0.603497615 8.01319555 5.11685215 6.76502385 6.26899841 4.07583466 6.17281399 0.522893482 2.57217806 0.138473768"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-209",
    fill: "#E87EA6",
    points: "198.130827 153.67097 192.981224 157.38035 192.347361 154.379555 195.495215 152.8069 198.130827 153.1538"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-213",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(190.972973, 158.526232)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-148",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-147"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0104928458,1.13465819 L0.449761526,2.98791733 C0.540858506,3.37027027 0.831319555,3.67392687 1.20969793,3.78044515 L1.20969793,3.78044515 L1.80667727,3.94848967 C2.21144674,4.06263911 2.64531002,3.93259141 2.92034976,3.61462639 L2.92034976,3.61462639 L4.00604134,2.35930048 L2.90158983,0.0545310016 L0.0104928458,1.13465819 Z",
    id: "Fill-211",
    fill: "url(#linearGradient-149)",
    mask: "url(#mask-148)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-216",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(193.834658, 155.982512)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-151",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-150"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-215"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0399046105,2.59825119 L0.904292528,7.2554849 L5.3518283,1.95580286 L5.34960254,1.94085851 C5.25786963,1.26327504 4.93513514,0.638314785 4.43593005,0.17154213 L4.43593005,0.17154213 L4.36120827,0.10127186 L0.0399046105,2.59825119 Z",
    id: "Fill-214",
    fill: "url(#linearGradient-152)",
    mask: "url(#mask-151)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-219",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(190.019078, 154.710652)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-154",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-153"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-218"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-217",
    fill: "url(#linearGradient-155)",
    mask: "url(#mask-154)",
    points: "1.64689984 0.749284579 0.0626391097 6.46248013 3.8554849 3.87011129 3.18346582 0.124960254"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-222",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(184.136725, 145.012719)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-157",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-156"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-221"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.135135135,0.0756756757 C0.135135135,0.0756756757 2.0554849,4.20524642 1.67154213,7.56597774 L1.67154213,7.56597774 C1.2872814,10.927186 2.39141494,12.6558029 6.52114467,11.3109698 L6.52114467,11.3109698 C10.6500795,9.96677266 10.9982512,8.08203498 10.9982512,8.08203498 L10.9982512,8.08203498 C14.1310016,9.73879173 15.4995231,6.31764706 15.4995231,6.31764706 L15.4995231,6.31764706 L16.0036566,5.41764706 L14.5874404,2.04435612 L8.24976153,0.0756756757 L0.135135135,0.0756756757 Z",
    id: "Fill-220",
    fill: "url(#linearGradient-158)",
    mask: "url(#mask-157)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-225",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(178.731320, 130.227345)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-160",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-159"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-224"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.306677266,9.29157393 C2.1073132,17.2139905 8.3009539,16.2777424 13.4146264,15.7736089 L13.4146264,15.7736089 C18.5281399,15.2694754 17.3399046,20.8510334 17.3399046,20.8510334 L17.3399046,20.8510334 C17.3399046,20.8510334 18.600159,19.3025437 19.7527822,19.3387917 L19.7527822,19.3387917 C20.9049285,19.3744038 20.9049285,21.1030207 20.9049285,21.1030207 L20.9049285,21.1030207 C25.2985692,20.3826709 24.8664547,16.4936407 23.4260731,15.7736089 L23.4260731,15.7736089 C21.9856916,15.0532591 21.3370429,14.3332273 21.9856916,11.4519873 L21.9856916,11.4519873 C22.6335453,8.57122417 20.3289348,6.84292528 16.3678855,8.21081081 L16.3678855,8.21081081 C12.4063593,9.57933227 14.4233704,6.62670906 11.1104928,2.08918919 L11.1104928,2.08918919 C10.1381558,0.757710652 8.65135135,0.145786963 7.08076312,0.145786963 L7.08076312,0.145786963 C3.29968203,0.145786963 -0.96518283,3.69411765 0.306677266,9.29157393",
    id: "Fill-223",
    fill: "url(#linearGradient-161)",
    mask: "url(#mask-160)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-228",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(130.718601, 198.907790)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-163",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-162"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-227"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-226",
    fill: "#5CCEFF",
    mask: "url(#mask-163)",
    points: "-7.59030207 138.325755 138.28283 138.325755 138.28283 -7.54753577 -7.59030207 -7.54753577"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-231",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(161.084261, 242.945946)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-165",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-164"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-230"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-229",
    fill: "#4D94FF",
    mask: "url(#mask-165)",
    points: "-7.56565978 94.2875994 107.917329 94.2875994 107.917329 -7.51971383 -7.56565978 -7.51971383"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-234",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(156.473768, 232.294118)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-167",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-166"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-233"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-232",
    fill: "#FFFFFF",
    mask: "url(#mask-167)",
    points: "-7.5136725 73.0297297 73.0205087 73.0297297 73.0205087 -7.50445151 -7.5136725 -7.50445151"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-237",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(173.166932, 244.535771)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-169",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-168"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-236"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-235",
    fill: "#4D94FF",
    mask: "url(#mask-169)",
    points: "-7.49220986 47.1124006 39.6127186 47.1124006 39.6127186 -7.5899841 -7.49220986 -7.5899841"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-240",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(115.138315, 119.257552)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-171",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-170"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-239"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-238",
    fill: "url(#linearGradient-172)",
    mask: "url(#mask-171)",
    points: "1.57217806 1.34801272 0.0340222576 2.64435612 0.745627981 5.42686804 3.23926868 3.32480127 5.73243243 1.22321145 3.11081081 0.0508744038"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-243",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(87.157393, 87.620032)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-174",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-173"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.76375199,2.39062003 C-2.00651828,7.25437202 -0.833068362,18.1394277 6.38489666,26.7022258 L6.38489666,26.7022258 C13.6028617,35.2655008 24.1319555,38.263752 29.9023847,33.3995231 L29.9023847,33.3995231 C35.6732909,28.5351351 34.499682,17.6507154 27.281876,9.08791733 L27.281876,9.08791733 C22.4076312,3.30524642 16.0241653,0.060572337 10.6149444,0.060572337 L10.6149444,0.060572337 C8.01399046,0.060572337 5.63767886,0.811128776 3.76375199,2.39062003",
    id: "Fill-241",
    fill: "url(#linearGradient-175)",
    mask: "url(#mask-174)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-250",
    opacity: 0.100000001,
    strokeWidth: 1,
    fill: "none",
    transform: "translate(88.111288, 87.937997)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-246"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-177",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-176"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-245"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0149444,2.25771065 C24.7343402,5.86375199 28.0042925,12.8435612 25.3187599,17.8475358 C22.6332273,22.8515103 15.009221,23.9848967 8.2899841,20.3788553 C1.57058824,16.772814 -1.69936407,9.79300477 0.986168521,4.78903021 C3.67170111,-0.215103339 11.2957075,-1.34833068 18.0149444,2.25771065",
    id: "Fill-244",
    fill: "url(#linearGradient-178)",
    mask: "url(#mask-177)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-249",
    opacity: 0.200000003,
    transform: "translate(3.497615, 0.635930)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-180",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-179"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-248"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9235294,2.03688394 C19.3841017,4.96756757 22.2806041,10.1942766 20.3931638,13.7114467 C18.5055644,17.2284579 12.5488076,17.7038156 7.08823529,14.7734499 C1.62766296,11.8429253 -1.26883943,6.61605723 0.618600954,3.0990461 C2.50620032,-0.417965024 8.46295707,-0.8936407 13.9235294,2.03688394",
    id: "Fill-247",
    fill: "url(#linearGradient-181)",
    mask: "url(#mask-180)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-253",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(258.858506, 97.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-183",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-182"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-252"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-251",
    fill: "url(#linearGradient-184)",
    mask: "url(#mask-183)",
    points: "0.0542130366 0.275834658 1.70492846 3.08791733 3.35612083 5.9 4.95421304 3.51351351 3.9354531 1.7782194 2.9163752 0.0429252782"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-256",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(260.925278, 73.152623)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-186",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-185"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-255"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9691574,3.84880763 C2.31128776,9.51923688 -2.4200318,19.3917329 1.40143084,25.900159 L1.40143084,25.900159 C5.22241653,32.4085851 16.1491256,33.0879173 25.8068362,27.4174881 L25.8068362,27.4174881 C35.4645469,21.7470588 40.1960254,11.8745628 36.3745628,5.36613672 L36.3745628,5.36613672 C34.2922099,1.81923688 30.0988871,0.00333863275 25.1510334,0.00333863275 L25.1510334,0.00333863275 C21.0201908,0.00333863275 16.363434,1.26868045 11.9691574,3.84880763",
    id: "Fill-254",
    fill: "url(#linearGradient-187)",
    mask: "url(#mask-186)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-263",
    opacity: 0.200000003,
    strokeWidth: 1,
    fill: "none",
    transform: "translate(270.623211, 73.311606)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-259"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-189",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-188"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-258"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2782194,0.318124006 C4.74165342,1.48044515 -0.666136725,6.97281399 0.199523052,12.5856916 C1.06502385,18.1984102 7.87647059,21.8060413 15.4130366,20.6437202 C22.9497615,19.4812401 28.3575517,13.9890302 27.4920509,8.37631161 C26.6262321,2.76343402 19.8149444,-0.844197138 12.2782194,0.318124006",
    id: "Fill-257",
    fill: "url(#linearGradient-190)",
    mask: "url(#mask-189)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-262",
    transform: "translate(2.543720, 0.635930)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-192",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-191"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-261"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1562798,0.27154213 C4.03131955,1.21621622 -0.440540541,5.1799682 0.168044515,9.12496025 C0.776311606,13.0696343 6.23481717,15.5019078 12.3594595,14.5572337 C18.4844197,13.6127186 22.9564388,9.64880763 22.3478537,5.70397456 C21.7394277,1.75898251 16.2810811,-0.673131955 10.1562798,0.27154213",
    id: "Fill-260",
    fill: "url(#linearGradient-193)",
    mask: "url(#mask-192)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-266",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(352.181240, 190.799682)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-195",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-194"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-265"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-264",
    fill: "url(#linearGradient-196)",
    mask: "url(#mask-195)",
    points: "1.22257552 1.66963434 0.0782193959 3.32480127 1.49554849 5.8227345 3.34992051 3.14022258 5.20445151 0.458187599 2.36709062 0.0144674086"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-269",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(318.635930, 165.044515)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-198",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-197"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-268"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.85405405,4.66899841 C-2.43799682,10.8771065 1.55039746,21.072337 10.7627981,27.4411765 L10.7627981,27.4411765 C19.9747218,33.8101749 30.9217806,33.9408585 35.2138315,27.7329094 L35.2138315,27.7329094 C39.5058824,21.5254372 35.5170111,11.3295707 26.3050874,4.96057234 L26.3050874,4.96057234 C21.6216216,1.72241653 16.49062,0.0972972973 12.0127186,0.0972972973 L12.0127186,0.0972972973 C7.68314785,0.0972972973 3.96406995,1.61748808 1.85405405,4.66899841",
    id: "Fill-267",
    fill: "url(#linearGradient-199)",
    mask: "url(#mask-198)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-279",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(235.170111, 204.313196)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-201",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-200"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-278"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.296979332,1.06979332 C0.296979332,1.06979332 1.01748808,3.08616852 0.333227345,4.63465819 L0.333227345,4.63465819 C-0.351033386,6.18330684 0.945468998,7.11955485 1.84562798,7.55166932 L1.84562798,7.55166932 C2.74610493,7.98394277 2.57806041,10.1683625 3.69459459,10.2046105 L3.69459459,10.2046105 C4.81096979,10.2403816 4.90651828,8.88394277 4.90651828,8.88394277 L4.90651828,8.88394277 C6.52702703,8.88394277 6.45516693,7.73195548 6.45516693,7.73195548 L6.45516693,7.73195548 C7.85977742,7.76756757 7.78775835,6.65119237 7.78775835,6.65119237 L7.78775835,6.65119237 C8.75977742,6.36343402 8.39952305,4.52718601 8.14753577,3.87853736 L8.14753577,3.87853736 C7.89554849,3.23052464 5.4227345,0.073608903 5.4227345,0.073608903 L5.4227345,0.073608903 L0.296979332,1.06979332 Z",
    id: "Fill-277",
    fill: "url(#linearGradient-202)",
    mask: "url(#mask-201)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-282",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(234.375199, 201.769475)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-204",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-203"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.216057234,1.70524642 C-0.16836248,3.33720191 0.792050874,4.29761526 0.792050874,4.29761526 L0.792050874,4.29761526 C3.91287758,4.87376789 6.88966614,2.90492846 6.88966614,2.90492846 L6.88966614,2.90492846 C7.03418124,1.84896661 6.02591415,0.0241653418 6.02591415,0.0241653418 L6.02591415,0.0241653418 C6.02591415,0.0241653418 1.41653418,1.03243243 0.216057234,1.70524642",
    id: "Fill-280",
    fill: "url(#linearGradient-205)",
    mask: "url(#mask-204)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-285",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(206.712242, 158.367250)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-207",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-206"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-284"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.09523052,1.2936407 C-1.19030207,5.11780604 -2.05786963,14.4977742 11.9863275,24.8155803 L11.9863275,24.8155803 C22.9499205,32.8709062 26.4863275,45.7745628 26.4863275,45.7745628 L26.4863275,45.7745628 C26.4863275,45.7745628 33.0403816,46.427504 34.9130366,42.9707472 L34.9130366,42.9707472 C34.9130366,42.9707472 31.1677266,23.6683625 23.24531,13.1534181 L23.24531,13.1534181 C17.0550079,4.93688394 9.50158983,0.135771065 5.02877583,0.135771065 L5.02877583,0.135771065 C3.7772655,0.135771065 2.76709062,0.511605723 2.09523052,1.2936407",
    id: "Fill-283",
    fill: "url(#linearGradient-208)",
    mask: "url(#mask-207)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-288",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(191.290938, 161.705882)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-210",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-209"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-287"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.244356121,0.0917329094 C-1.66279809,9.65882353 8.3936407,21.6503975 18.8607313,25.9715421 L18.8607313,25.9715421 C29.3279809,30.2928458 29.0397456,35.7666137 29.0397456,35.7666137 L29.0397456,35.7666137 L37.4903021,38.6473768 L40.2750397,28.9484897 C35.7616852,20.1139905 28.6558029,19.2496025 16.0755167,15.0244833 L16.0755167,15.0244833 C3.49586645,10.7988871 1.91160572,0.0917329094 1.91160572,0.0917329094 L1.91160572,0.0917329094 L0.244356121,0.0917329094 Z",
    id: "Fill-286",
    fill: "url(#linearGradient-211)",
    mask: "url(#mask-210)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinalSetup);
export default __webpack_public_path__ + "static/media/final_setup.a2d7ef1645934157b0d938ea43e582d6.svg";
export { ForwardRef as ReactComponent };